
let LAST_TEMPLATE_JSON = null;

(function () {
  const unlockScroll = () => { document.documentElement.style.overflow = ""; };
  // -----------------------------
  // Form detection (Shopify)
  // -----------------------------
  const productForm =
    document.querySelector('[data-product-form] form') ||
    document.querySelector('form[action*="/cart/add"]') ||
    document.querySelector('form[action="/cart/add"]');

  const productFormId = productForm?.getAttribute("id") || "";

  // -----------------------------
  // Boot helpers
  // -----------------------------
  function whenReady(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function waitForLibs(cb) {
    const start = Date.now();
    (function tick() {
      const ok = window.fabric; // docx not required
      if (ok) return cb();
      if (Date.now() - start > 12000) {
        console.warn("Engrave: libraries did not load (fabric).");
        return;
      }
      setTimeout(tick, 50);
    })();
  }

  function decodeHtmlEntities(str) {
    return String(str || "")
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .replace(/&amp;/g, "&");
  }

  function cleanUrl(u) {
    return String(u || "")
      .trim()
      .replace(/&amp;/g, "&")
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'");
  }

  // -----------------------------
  // ✅ Background apply helper (CRITICAL FIX)
  // Applies to both:
  //   - .ecPreviewInner (what user sees + what html2canvas captures)
  //   - [data-stage] (fallback)
  // -----------------------------
  function applyBgImageToApp(root, imgUrl) {
    const url = String(imgUrl || "").trim();
    if (!root || !url) return;

    const stage = root.querySelector("[data-stage]");
    const preview =
      root.querySelector(".ecPreviewInner") ||
      (stage ? stage.closest(".ecPreviewInner") : null) ||
      stage;

    if (preview) {
      preview.style.setProperty("background-image", `url("${url}")`, "important");
      preview.style.setProperty("background-repeat", "no-repeat", "important");
      preview.style.setProperty("background-position", "center", "important");
      preview.style.setProperty("background-size", "cover", "important");
    }

    if (stage && stage !== preview) {
      stage.style.setProperty("background-image", `url("${url}")`, "important");
      stage.style.setProperty("background-repeat", "no-repeat", "important");
      stage.style.setProperty("background-position", "center", "important");
      stage.style.setProperty("background-size", "cover", "important");
    }
  }

  // -----------------------------
  // Init all apps on page
  // -----------------------------
  whenReady(function () {
    const apps = document.querySelectorAll("[data-engrave-app]");
    if (!apps.length) return;

    waitForLibs(function () {
      apps.forEach(initApp);
    });
  });

  function initApp(root) {
    // -----------------------------
    // Read config from HTML
    // -----------------------------
    const zoneW = Number(root.getAttribute("data-zone-w") || 720);
    const zoneH = Number(root.getAttribute("data-zone-h") || 960);
    const photo = root.getAttribute("data-product-photo") || "";
    const jsonDataContain = document.querySelector('[data-template]').getAttribute("data-template-json");
    // const MAX_TEXT_FIELDS = 5;
    const jsonData = JSON.parse(decodeHtmlEntities(jsonDataContain));
    const MAX_TEXT_FIELDS = jsonData?.maxFields?.noField ?? 5;

    root.style.setProperty("--zone-w", zoneW + "px");
    root.style.setProperty("--zone-h", zoneH + "px");

    const stage = root.querySelector("[data-stage]");

    // ✅ If template was selected before Fabric finished loading, apply stored bg now
    const pendingImg = root.getAttribute("data-active-bg-image") || "";
    if (pendingImg) {
      applyBgImageToApp(root, pendingImg);
    } else if (stage && photo) {
      // ✅ Only apply product photo if NO template BG was selected
      stage.style.backgroundImage = `url("${photo}")`;
    }

    const canvasEl = root.querySelector("[data-canvas]");
    const fieldsRoot = root.querySelector("[data-fields]");
    if (!canvasEl || !fieldsRoot) return;

    // -----------------------------
    // ✅ Stable Panel Order
    // -----------------------------
    let __panelOrderSeed = 1;

    function ensurePanelOrder(obj) {
      obj.data = obj.data || {};
      if (obj.data.panelOrder == null) obj.data.panelOrder = __panelOrderSeed++;
      return obj.data.panelOrder;
    }

    function getTextFieldCount() {
  return canvas.getObjects().filter(o =>
    o.type === "textbox" || (o.data && o.data.isCurved)
  ).length;
}
    function clonePanelOrder(fromObj, toObj) {
      const order = fromObj?.data?.panelOrder;
      toObj.data = toObj.data || {};
      if (order != null) toObj.data.panelOrder = order;
      else ensurePanelOrder(toObj);
    }

    // -----------------------------
    // ✅ FIX: declare before use
    // -----------------------------
    let __suppressPanelAutoScroll = false;
    let __isCurveAdjusting = false;

    // -----------------------------
    // Fabric canvas
    // -----------------------------
    const canvas = new fabric.Canvas(canvasEl, {
      selection: true,
      preserveObjectStacking: true
    });

    canvas.setWidth(zoneW);
    canvas.setHeight(zoneH);
    canvas.calcOffset();
    canvas.requestRenderAll();

    function resizeFabricToCSS() {
      canvas.calcOffset();
      canvas.requestRenderAll();
    }
    window.addEventListener("resize", resizeFabricToCSS);
    setTimeout(resizeFabricToCSS, 50);

    // Expose active app (single instance)
    window.__ofaEngraveApp = { root, canvas, stage };

    // -----------------------------
    // Inject Curve UI styles
    // -----------------------------
    (function injectCurveStyles() {
      if (root.querySelector("style[data-curve-ui]")) return;
      const st = document.createElement("style");
      st.setAttribute("data-curve-ui", "1");
      st.textContent = `
        .ofaCurveBar{
          position:relative;
          height:28px;
          flex:1;
          min-width:160px;
          border:0px;
          border-radius:0px;
          background:#fff;
          cursor:pointer;
          display:flex;
          align-items:center;
          padding:0 10px;
          box-sizing:border-box;
          outline:0px;
        }
        .ofaCurveTrack{
          position:absolute;
          left:10px; right:10px;
          height:6px;
          border-radius:999px;
          background:#e5e7eb;
          top:50%;
          transform:translateY(-50%);
          width:90%;
        }
        .ofaCurveTicks{
          position:absolute;
          left:10px; right:10px;
          height:6px;
          top:50%;
          width:90%;
          transform:translateY(-50%);
          background:
            repeating-linear-gradient(
              to right,
              transparent 0,
              transparent calc(10% - 1px),
              #cbd5e1 calc(10% - 1px),
              #cbd5e1 calc(10% + 0px)
            );
          opacity:.9;
          border-radius:999px;
          pointer-events:none;
        }
        .ofaCurveThumb{
          position:absolute;
          top:50%;
          transform:translate(-50%,-50%);
          width:10px;
          height:10px;
          border-radius:999px;
          background:#d4a73a;
          box-shadow:0 0 0 2px #fff;
          pointer-events:none;
        }
      `;
      root.appendChild(st);
    })();

    // -----------------------------
    // Helpers: clamp / scale
    // -----------------------------
    function clampToCanvas(o) {
      if (!o) return;
      const b = o.getBoundingRect(true, true);
      const W = canvas.getWidth(), H = canvas.getHeight();
      let left = o.left, top = o.top;
      if (b.left < 0) left += (0 - b.left);
      if (b.top < 0) top += (0 - b.top);
      if (b.left + b.width > W) left -= (b.left + b.width - W);
      if (b.top + b.height > H) top -= (b.top + b.height - H);
      o.set({ left, top });
    }

    function clampScale(o) {
      if (!o) return;
      const b = o.getBoundingRect(true, true);
      const W = canvas.getWidth(), H = canvas.getHeight();
      if (b.width > W) {
        const s = (W - 10) / b.width;
        o.scaleX *= s; o.scaleY *= s;
      }
      if (b.height > H) {
        const s = (H - 10) / b.height;
        o.scaleX *= s; o.scaleY *= s;
      }
    }

    // -----------------------------
    // Custom controls
    // -----------------------------
    const dragHandler = fabric.controlsUtils.dragHandler;
    const changeWidth = fabric.controlsUtils.changeWidth;
    const scaleUniform = fabric.controlsUtils.scalingEqually;

    const icon = {
      del(ctx, left, top, style, obj) {
        const s = 24;
        ctx.save(); ctx.translate(left, top);
        ctx.rotate(fabric.util.degreesToRadians(obj.angle || 0));
        ctx.fillStyle = "#1a1012"; ctx.strokeStyle = "#3a1f22";
        ctx.lineWidth = 1.5; ctx.beginPath(); ctx.arc(0, 0, s / 2, 0, Math.PI * 2); ctx.fill(); ctx.stroke();
        ctx.strokeStyle = "#ff9ca0"; ctx.lineWidth = 2;
        ctx.beginPath(); ctx.moveTo(-4, 2); ctx.lineTo(4, 2); ctx.stroke();
        ctx.strokeRect(-6, -6, 12, 8);
        ctx.beginPath();
        ctx.moveTo(-2, -6); ctx.lineTo(-2, 2);
        ctx.moveTo(0, -6); ctx.lineTo(0, 2);
        ctx.moveTo(2, -6); ctx.lineTo(2, 2);
        ctx.stroke();
        ctx.restore();
      },
      drag(ctx, left, top, style, obj) {
        const s = 24;
        ctx.save(); ctx.translate(left, top);
        ctx.rotate(fabric.util.degreesToRadians(obj.angle || 0));
        ctx.fillStyle = "#0f1520"; ctx.strokeStyle = "#1d314f";
        ctx.lineWidth = 1.5; ctx.beginPath(); ctx.arc(0, 0, s / 2, 0, Math.PI * 2); ctx.fill(); ctx.stroke();
        ctx.strokeStyle = "#cfe3ff"; ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.moveTo(0, -6); ctx.lineTo(0, 6);
        ctx.moveTo(-6, 0); ctx.lineTo(6, 0);
        ctx.stroke();
        ctx.restore();
      },
      expand(ctx, left, top, style, obj) {
        const s = 24;
        ctx.save(); ctx.translate(left, top);
        ctx.rotate(fabric.util.degreesToRadians(obj.angle || 0));
        ctx.fillStyle = "#0f1520"; ctx.strokeStyle = "#1d314f";
        ctx.lineWidth = 1.5; ctx.beginPath(); ctx.arc(0, 0, s / 2, 0, Math.PI * 2); ctx.fill(); ctx.stroke();
        ctx.strokeStyle = "#cfe3ff"; ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.moveTo(-6, 0); ctx.lineTo(6, 0);
        ctx.moveTo(-6, 0); ctx.lineTo(-2, -4);
        ctx.moveTo(-6, 0); ctx.lineTo(-2, 4);
        ctx.moveTo(6, 0); ctx.lineTo(2, -4);
        ctx.moveTo(6, 0); ctx.lineTo(2, 4);
        ctx.stroke();
        ctx.restore();
      },
      scale(ctx, left, top, style, obj) {
        const s = 24;
        ctx.save(); ctx.translate(left, top);
        ctx.rotate(fabric.util.degreesToRadians(obj.angle || 0));
        ctx.fillStyle = "#0f1520"; ctx.strokeStyle = "#1d314f";
        ctx.lineWidth = 1.5; ctx.beginPath(); ctx.arc(0, 0, s / 2, 0, Math.PI * 2); ctx.fill(); ctx.stroke();
        ctx.strokeStyle = "#cfe3ff"; ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.moveTo(-5, 5); ctx.lineTo(5, -5);
        ctx.moveTo(5, -5); ctx.lineTo(1, -5);
        ctx.moveTo(5, -5); ctx.lineTo(5, -1);
        ctx.stroke();
        ctx.restore();
      }
    };

    // -----------------------------
    // Panel helpers
    // -----------------------------
    function ensureFieldId(obj) {
      obj.data = obj.data || {};
      if (!obj._id) obj._id = `o${Date.now()}${Math.floor(Math.random() * 1000)}`;
      if (!obj.data.fieldId) obj.data.fieldId = obj._id;
      return obj.data.fieldId;
    }

    function isTextLike(o) {
      return o && (o.type === "textbox" || (o.data && o.data.isCurved));
    }

    function getTextValue(o) {
      if (!o) return "";
      if (o.type === "textbox") return o.text || "";
      if (o.data?.isCurved) return o.data.text || "";
      return "";
    }

    function setTextValue(o, val) {
      if (!o) return;
      if (o.type === "textbox") o.set({ text: val });
      if (o.data?.isCurved) o.data.text = val;
    }

    function getFontFamily(o) {
      if (o.type === "textbox") return o.fontFamily || "Georgia";
      return o.data?.fontFamily || "Georgia";
    }

    function getFontSize(o) {
      if (o.type === "textbox") return Number(o.fontSize || 50);
      return Number(o.data?.fontSize || 50);
    }

    function getFontWeight(o) {
      if (o.type === "textbox") return o.fontWeight || "normal";
      return o.data?.fontWeight || "normal";
    }

    function getFontStyle(o) {
      if (o.type === "textbox") return o.fontStyle || "normal";
      return o.data?.fontStyle || "normal";
    }

    function getTextAlign(o) {
      if (o.type === "textbox") return o.textAlign || "center";
      return o.data?.textAlign || "center";
    }

    function getFill(o) {
      if (o.type === "textbox") return o.fill || "#ffffff";
      return o.data?.fill || "#ffffff";
    }

    // -----------------------------
    // Attach Fabric custom controls
    // -----------------------------
    function attachControls(obj) {
      if (!obj) return;

      obj.setControlsVisibility({
        tl: true, tc: true, mr: true, br: true,
        tr: false, ml: false, mt: false, mb: false, bl: false, mtr: false
      });

      if (obj?.type === "group" && obj?.data?.isCurved) {
        obj.setControlsVisibility({ mr: false });
      }

      obj.controls.tl = new fabric.Control({
        x: -0.5, y: -0.5, offsetX: -10, offsetY: -10,
        cursorStyle: "pointer",
        mouseUpHandler: function (e, tr) {
          removeFieldForObject(tr.target);
          canvas.remove(tr.target);
          canvas.discardActiveObject();
          canvas.requestRenderAll();
          return true;
        },
        render: icon.del,
        cornerSize: 28
      });

      obj.controls.tc = new fabric.Control({
        x: 0, y: -0.5, offsetY: -10,
        cursorStyle: "move",
        actionHandler: function (e, tr, x, y) {
          const r = dragHandler(e, tr, x, y);
          clampToCanvas(tr.target);
          syncPanelSelection(tr.target);
          return r;
        },
        render: icon.drag,
        cornerSize: 28
      });

      obj.controls.mr = new fabric.Control({
        x: 0.5, y: 0, offsetX: 10,
        cursorStyle: "e-resize",
        actionHandler: function (e, tr, x, y) {
          const r = changeWidth(e, tr, x, y);
          clampToCanvas(tr.target);
          return r;
        },
        render: icon.expand,
        cornerSize: 28
      });

      obj.controls.br = new fabric.Control({
        x: 0.5, y: 0.5, offsetX: 10, offsetY: 10,
        cursorStyle: "se-resize",
        actionHandler: function (e, tr, x, y) {
          const r = scaleUniform(e, tr, x, y);
          clampScale(tr.target);
          clampToCanvas(tr.target);
          return r;
        },
        render: icon.scale,
        cornerSize: 28
      });
    }

    // -----------------------------
    // Text objects
    // -----------------------------
    let nextId = 1;
    function newTextbox(text) {
      const t = new fabric.Textbox(text || "New Text", {
        left: 80,
        top: 80,
        width: zoneW - 160,
        fontSize: 30,
        fontFamily: "Arial",
        textAlign: "center",
        fill: "#000000",
        editable: true,
        transparentCorners: false,
        borderColor: "#7aa2ff",
        cornerColor: "#7aa2ff",
        cornerStyle: "circle"
      });
      t._id = `t${nextId++}`;
      attachControls(t);
      return t;
    }

    // =========================================================
    // ✅ CURVE FEATURE (unchanged)
    // =========================================================
    function curveStrengthToRadius(strength) {
      const MAX = 300;
      let v = Number(strength || 0);
      v = Math.max(-MAX, Math.min(MAX, v));

      if (Math.abs(v) < 8) return { v: 0, radius: 0, dir: 0 };

      const k = Math.abs(v) / MAX;

      const BASE = 100;
      let radius = BASE / k;

      radius = Math.max(180, Math.min(12000, radius));

      const dir = v > 0 ? -1 : 1;
      return { v, radius, dir };
    }

    function buildCurvedGroup({
      text,
      fontSize,
      fontFamily,
      fontWeight,
      fontStyle,
      fill,
      textAlign,
      radius,
      dir
    }) {
      const str = String(text ?? "");
      const chars = str.length ? str.split("") : [" "];

      const widths = chars.map((ch) => {
        const t = new fabric.Text(ch === " " ? " " : ch, {
          fontFamily,
          fontSize,
          fontWeight,
          fontStyle
        });
        return Math.max(1, t.width || fontSize * 0.45);
      });

      const tracking = Math.max(0, fontSize * 0.08);

      const totalPx =
        widths.reduce((a, w) => a + w, 0) + Math.max(0, (widths.length - 1) * tracking);

      let totalRad = totalPx / radius;

      const maxRad = (170 * Math.PI) / 180;
      totalRad = Math.min(totalRad, maxRad);

      let startRad = -totalRad / 2;
      if (textAlign === "left") startRad = 0;
      if (textAlign === "right") startRad = -totalRad;

      let acc = 0;
      const letters = [];

      for (let i = 0; i < chars.length; i++) {
        const w = widths[i];
        const mid = acc + w / 2;

        const a = startRad + (mid / totalPx) * totalRad;

        const x = Math.sin(a) * radius;
        const y = dir * (radius * (1 - Math.cos(a)));

        const aDeg = fabric.util.radiansToDegrees(a);
        const rot = dir * aDeg;

        const ch = new fabric.Text(chars[i], {
          fontSize,
          fontFamily,
          fontWeight,
          fontStyle,
          fill,
          originX: "center",
          originY: "center",
          left: x,
          top: y,
          angle: rot,
          selectable: false,
          evented: false
        });

        letters.push(ch);
        acc += w + tracking;
      }

      return new fabric.Group(letters, {
        originX: "center",
        originY: "top",
        selectable: true,
        evented: true
      });
    }

    function applyCurveToObject(obj, curveValue) {
      if (!isTextLike(obj)) return;

      __suppressPanelAutoScroll = true;

      const { v, radius, dir } = curveStrengthToRadius(curveValue);

      const cx = (obj.left ?? canvas.getWidth() / 2);
      const cy = (obj.top ?? canvas.getHeight() / 2);
      const keepAngle = obj.angle || 0;
      const keepScaleX = obj.scaleX || 1;
      const keepScaleY = obj.scaleY || 1;

      const text = getTextValue(obj);
      const fontSize = getFontSize(obj);
      const fontFamily = getFontFamily(obj);
      const fill = getFill(obj);
      const fontWeight = getFontWeight(obj);
      const fontStyle = getFontStyle(obj);
      const textAlign = getTextAlign(obj);

      const fieldId = obj.data?.fieldId || obj._id || `t${Date.now()}`;

      canvas.remove(obj);

      if (!radius) {
        const t = new fabric.Textbox(text || "", {
          left: cx,
          top: cy,
          originX: "center",
          originY: "top",
          width: Math.max(120, canvas.getWidth() - 160),
          fontSize,
          fontFamily,
          fontWeight,
          fontStyle,
          textAlign,
          fill,
          editable: true,
          transparentCorners: false,
          borderColor: "#7aa2ff",
          cornerColor: "#7aa2ff",
          cornerStyle: "circle",
          angle: keepAngle,
          scaleX: keepScaleX,
          scaleY: keepScaleY
        });

        t.data = { ...(obj.data || {}), fieldId, curve: 0 };
        clonePanelOrder(obj, t);
        t._id = obj._id || fieldId;

        attachControls(t);
        canvas.add(t);
        canvas.setActiveObject(t);
        try { clampScale(t); clampToCanvas(t); } catch (e) {}
        canvas.requestRenderAll();

        setTimeout(() => { __suppressPanelAutoScroll = false; }, 0);
        return;
      }

      const group = buildCurvedGroup({
        text,
        fontSize,
        fontFamily,
        fontWeight,
        fontStyle,
        fill,
        textAlign,
        radius,
        dir
      });

      group.set({
        left: cx,
        top: cy,
        originX: "center",
        originY: "top",
        angle: keepAngle,
        scaleX: keepScaleX,
        scaleY: keepScaleY
      });

      group.data = {
        ...(obj.data || {}),
        fieldId,
        isCurved: true,
        curve: v,
        text,
        fontSize,
        fontFamily,
        fontWeight,
        fontStyle,
        textAlign,
        fill
      };
      clonePanelOrder(obj, group);
      group._id = obj._id || fieldId;

      attachControls(group);
      canvas.add(group);
      canvas.setActiveObject(group);

      try { clampScale(group); clampToCanvas(group); } catch (e) {}
      canvas.requestRenderAll();
      renderPanel();
      setTimeout(() => { __suppressPanelAutoScroll = false; }, 0);
    }

    // -----------------------------
    // LOGO add (from JSON)
    // -----------------------------
    function addLogoFromJSON(logo, yForFlow) {
      return new Promise((resolve) => {
        if (!logo || !logo.url) return resolve(null);

        const url = cleanUrl(logo.url);

        fabric.Image.fromURL(
          url,
          (img) => {
            if (!img) return resolve(null);

            const canEdit = (logo.selectable !== false);

            img.set({
              originX: "center",
              originY: "top",
              left: canvas.getWidth() / 2,
              top: Number(yForFlow ?? 0),
              selectable: canEdit,
              evented: canEdit,
              hasControls: canEdit,
              hasBorders: canEdit
            });

            if (logo.width) img.scaleToWidth(Number(logo.width));
            else if (logo.height) img.scaleToHeight(Number(logo.height));
            else if (logo.scale) img.scale(Number(logo.scale));
            else img.scaleToWidth(200);

            img.data = img.data || {};
            img.data.isLogo = true;
            img.data.fieldId = logo.id || "logo";

            attachControls(img);
            img.setCoords();

            canvas.add(img);
            canvas.requestRenderAll();
            resolve(img);
          },
          { crossOrigin: "anonymous" }
        );
      });
    }

    async function fileToDataUrl(file) {
      return await new Promise((resolve, reject) => {
        const fr = new FileReader();
        fr.onload = () => resolve(fr.result);
        fr.onerror = reject;
        fr.readAsDataURL(file);
      });
    }

    // -----------------------------
    // Template apply
    // -----------------------------
    function clearTemplate() {
      canvas.getObjects().slice().forEach(o => canvas.remove(o));
      canvas.discardActiveObject();
      canvas.requestRenderAll();
    }

    async function applyTemplateFromJSON(tpl) {
      if (!tpl) return;

      clearTemplate();

      const layout = tpl.layout || {};
      const items = tpl.fields || tpl.lines || [];
              console.log(tpl);
      const cx = canvas.getWidth() / 2;
      const defaultGap = Number(layout.gap ?? 14);
      const startY = Number(layout.startY ?? 140);
      const widthPadding = Number(layout.widthPadding ?? 80);
      const defaultWidth = canvas.getWidth() - widthPadding;

      let y = startY;

      for (const l of items) {

        const type = (l.type || "text").toLowerCase();

        if (type === "image" || type === "logo") {
          const img = await addLogoFromJSON(l, y);
          if (img) {
            const realH = img.getScaledHeight();
            const gap = (l.gap != null ? Number(l.gap) : defaultGap);
            y += realH + gap;
          }
          continue;
        }

        const t = newTextbox(l.text || "");
        t.data = t.data || {};
        t.data.fieldId = l.id || t._id;
        t._label = l.label || "";

        t.set({
          width: Number(l.width ?? defaultWidth),
          textAlign: l.textAlign ?? "center",
          fontSize: Number(l.fontSize ?? l.size ?? 36),
          fontFamily: l.fontFamily ?? l.font ?? "Arial",
          fontStyle: l.fontStyle ?? l.style ?? "normal",
          fontWeight: l.fontWeight ?? l.weight ?? "normal",
          fill: l.fill ?? "#ffffff",
          left: cx,
          top: y,
          originX: "center",
          originY: "top"
        });

        t.initDimensions();
        t.setCoords();
        canvas.add(t);

        const curveVal = Number(l.curve || 0);

        if (curveVal) {
          canvas.setActiveObject(t);
          applyCurveToObject(t, curveVal);

          const last = canvas.getObjects().slice(-1)[0];
          const realH = last?.getScaledHeight?.() || 0;
          const gap = (l.gap != null ? Number(l.gap) : defaultGap);
          y += realH + gap;
        } else {
          const realH = t.getScaledHeight();
          const gap = (l.gap != null ? Number(l.gap) : defaultGap);
          y += realH + gap;
        }
      }

      canvas.setActiveObject(canvas.getObjects("textbox")[0] || null);
      canvas.requestRenderAll();
      renderPanel();
    }

    // =========================================================
    // MULTI-PAGE (Quantity)
    // =========================================================
    const pageState = {
      qty: 1,
      activeIndex: 0,
      pages: []
    };

    const pageSelect = root.querySelector("[data-page-select]");
    const btnPrev = root.querySelector("[data-page-prev]");
    const btnNext = root.querySelector("[data-page-next]");
    const qtyInputEl = root.querySelector("[data-qty-input]");
    const btnQtyInc = root.querySelector("[data-qty-inc]");
    const btnQtyDec = root.querySelector("[data-qty-dec]");

    // ✅ NEW: BULK checkbox
    const bulkCheckbox =
      root.querySelector("#ofaBulkAddSingleLine") ||
      document.getElementById("ofaBulkAddSingleLine");

    function isBulkMode() {
      return !!(bulkCheckbox && bulkCheckbox.checked);
    }

    function safeJSON() {
      return canvas.toJSON(["data", "_id", "_label"]);
    }

    function ensurePages(n) {
      while (pageState.pages.length < n) pageState.pages.push({ json: null, tpl: null });
      while (pageState.pages.length > n) pageState.pages.pop();
      pageState.qty = n;
      pageState.activeIndex = Math.max(0, Math.min(pageState.activeIndex, n - 1));
    }

    function updateQtyUI() {
      if (qtyInputEl) qtyInputEl.value = String(pageState.qty);

      if (pageSelect) {
        pageSelect.innerHTML = "";
        for (let i = 0; i < pageState.qty; i++) {
          const opt = document.createElement("option");
          opt.value = String(i);
          opt.textContent = `Item ${i + 1}`;
          if (i === pageState.activeIndex) opt.selected = true;
          pageSelect.appendChild(opt);
        }
      }

      if (btnPrev) btnPrev.disabled = pageState.activeIndex <= 0;
      if (btnNext) btnNext.disabled = pageState.activeIndex >= pageState.qty - 1;
    }

    function saveActivePage() {
      const p = pageState.pages[pageState.activeIndex];
      if (!p) return;
      p.json = safeJSON();
    }

    function loadPage(index, { fallbackTemplate = null } = {}) {
      const p = pageState.pages[index];
      if (!p) return;

      canvas.discardActiveObject();
      canvas.clear();

      if (p.json) {
        canvas.loadFromJSON(p.json, () => {
          canvas.getObjects().forEach(o => {
            if (o) {
              attachControls(o);
              if (o?.data?.isLogo) {
                o.selectable = true;
                o.evented = true;
                o.hasControls = true;
                o.hasBorders = true;
              }
              o.setCoords?.();
            }
          });

          canvas.requestRenderAll();
          renderPanel();
        });
        return;
      }

      const tpl = p.tpl || fallbackTemplate || LAST_TEMPLATE_JSON || null;
      if (tpl) {
        window.ofaApplyTemplateJSON?.(tpl);
        return;
      }

      canvas.requestRenderAll();
      renderPanel();
    }

    function setActivePage(index) {
      index = Number(index);
      if (Number.isNaN(index)) return;

      saveActivePage();
      pageState.activeIndex = Math.max(0, Math.min(index, pageState.qty - 1));
      updateQtyUI();

      const fallbackTpl =
        pageState.pages[pageState.activeIndex].tpl ||
        pageState.pages[0]?.tpl ||
        null;

      loadPage(pageState.activeIndex, { fallbackTemplate: fallbackTpl });
    }

    function setQty(newQty) {
      newQty = Math.max(1, Math.min(999, Number(newQty) || 1));

      saveActivePage();

      const oldQty = pageState.qty;
      ensurePages(newQty);

      if (newQty > oldQty) {
        const tplToUse =
          LAST_TEMPLATE_JSON ||
          pageState.pages[pageState.activeIndex]?.tpl ||
          pageState.pages[0]?.tpl ||
          null;

        for (let i = oldQty; i < newQty; i++) {
          pageState.pages[i].tpl = tplToUse;
          pageState.pages[i].json = null;
        }
        pageState.activeIndex = newQty - 1;
      } else {
        pageState.activeIndex = Math.max(0, Math.min(pageState.activeIndex, newQty - 1));
      }

      updateQtyUI();
      loadPage(pageState.activeIndex, { fallbackTemplate: pageState.pages[pageState.activeIndex].tpl });
    }

    if (btnQtyInc) btnQtyInc.addEventListener("click", () => setQty(pageState.qty + 1));
    if (btnQtyDec) btnQtyDec.addEventListener("click", () => setQty(pageState.qty - 1));
    if (qtyInputEl) qtyInputEl.addEventListener("change", () => setQty(qtyInputEl.value));

    if (pageSelect) pageSelect.addEventListener("change", (e) => setActivePage(e.target.value));
    if (btnPrev) btnPrev.addEventListener("click", () => setActivePage(pageState.activeIndex - 1));
    if (btnNext) btnNext.addEventListener("click", () => setActivePage(pageState.activeIndex + 1));

    ensurePages(1);
    updateQtyUI();

    // ✅ NEW: quantity field toggle for bulk/split
    function syncQtyNameAttrForMode() {
      if (!qtyInputEl) return;

      const formId =
        qtyInputEl.getAttribute("data-form-id") ||
        productFormId ||
        productForm?.getAttribute("id") ||
        "";

      if (isBulkMode()) {
        if (formId) qtyInputEl.setAttribute("form", formId);
        qtyInputEl.setAttribute("name", "quantity");
      } else {
        qtyInputEl.removeAttribute("name");
        qtyInputEl.removeAttribute("form");
      }
    }

    if (bulkCheckbox) bulkCheckbox.addEventListener("change", syncQtyNameAttrForMode);
    syncQtyNameAttrForMode();

    // expose base template apply
    window.__ofaApplyTemplateBase = applyTemplateFromJSON;

    window.ofaSetCustomizerBackground = function (imgUrl) {
      applyBgImageToApp(root, imgUrl);
      try {
        canvas.setBackgroundColor(null, canvas.requestRenderAll.bind(canvas));
        if (canvas.upperCanvasEl) canvas.upperCanvasEl.style.background = "transparent";
        if (canvas.lowerCanvasEl) canvas.lowerCanvasEl.style.background = "transparent";
      } catch (e) {}
    };

    window.ofaApplyTemplateJSON = async function (tpl) {
      LAST_TEMPLATE_JSON = tpl;

      if (pageState.pages[pageState.activeIndex]) {
        pageState.pages[pageState.activeIndex].tpl = tpl;
        pageState.pages[pageState.activeIndex].json = null;
      }

      await window.__ofaApplyTemplateBase(tpl);
      saveActivePage();
    };

    // -----------------------------
    // Right panel templates
    // -----------------------------
    function cardHTMLLogo(obj) {
      const fieldId = ensureFieldId(obj);
      return `
        <div class="field field--logo" data-field-id="${fieldId}">
        <p style="color:#fff;font-weight:600;">Logo Settings</p>
          <div class="row" style="gap:10px; align-items:center;">
            <div style="font-weight:600; color:#fff;"></div>
          </div>
          <div class="row" style="gap:10px; margin-top:0px;">
            <button type="button" class="btn-sm js-logo-replace">Replace</button>
            <button type="button" class="btn-sm btn-danger js-logo-delete">Delete</button>
          </div>
        </div>
      `;
    }

    function cardHTMLText(obj) {
      const fieldId = ensureFieldId(obj);
      const val = (getTextValue(obj) || "").replace(/</g, "&lt;");

      const ff = getFontFamily(obj);
      const fs = getFontSize(obj);
      const fw = getFontWeight(obj);
      const fst = getFontStyle(obj);

      const curveVal = Number(obj.data?.curve || 0);
      const curvePct = Math.round(((curveVal + 300) / 600) * 100);

      return `
        <div class="field" data-field-id="${fieldId}">
          <textarea class="input js-text" rows="2"
            form="${productFormId}"
            name="properties[${fieldId}]"
            placeholder="Type…"
          >${val}</textarea>

          <div class="row">
            <select class="select js-font">
              <option value="Helvetica" ${ff === "Helvetica" ? "selected" : ""}>Helvetica</option>
              <option value="Arial" ${ff === "Arial" ? "selected" : ""}>Arial</option>
              <option value="Times New Roman" ${ff === "Times New Roman" ? "selected" : ""}>Times New Roman</option>
              <option value="Courier New" ${ff === "Courier New" ? "selected" : ""}>Courier New</option>
              <option value="Calibri" ${ff === "Calibri" ? "selected" : ""}>Calibri</option>
              <option value="Verdana" ${ff === "Verdana" ? "selected" : ""}>Verdana</option>
              <option value="Tahoma" ${ff === "Tahoma" ? "selected" : ""}>Tahoma</option>
              <option value="Trebuchet MS" ${ff === "Trebuchet MS" ? "selected" : ""}>Trebuchet MS</option>
              <option value="Georgia" ${ff === "Georgia" ? "selected" : ""}>Georgia</option>
              <option value="Garamond" ${ff === "Garamond" ? "selected" : ""}>Garamond</option>
              <option value="Graduate" ${ff === "Graduate" ? "selected" : ""}>Graduate</option>
              <option value="Trajan Pro" ${ff === "Trajan Pro" ? "selected" : ""}>Trajan Pro</option>
              <option value="Roboto" ${ff === "Roboto" ? "selected" : ""}>Roboto</option>
              <option value="Poppins" ${ff === "Poppins" ? "selected" : ""}>Poppins</option>
              <option value="Rouge Script" ${ff === "Rouge Script" ? "selected" : ""}>Rouge Script</option>
              <option value="Pinyon Script" ${ff === "Pinyon Script" ? "selected" : ""}>Pinyon Script</option>
              <option value="Dancing Script" ${ff === "Dancing Script" ? "selected" : ""}>Dancing Script</option>
            </select>

            <div class="row">
              <button type="button" class="btn-sm js-size-dec">−</button>
              <input class="input num js-size" type="number" min="8" max="200" step="1" value="${Math.round(fs)}">
              <button type="button" class="btn-sm js-size-inc">+</button>
            </div>

            <button type="button" class="btn-sm btn-toggle js-bold" aria-pressed="${fw === "bold"}"><b>B</b></button>
            <button type="button" class="btn-sm btn-toggle js-italic" aria-pressed="${fst === "italic"}"><i>I</i></button>

            <div class="row">
              <button type="button" class="btn-sm js-align" data-align="left">⟸</button>
              <button type="button" class="btn-sm js-align" data-align="center">≡</button>
              <button type="button" class="btn-sm js-align" data-align="right">⟹</button>
            </div>

            <button type="button" class="btn-sm btn-danger js-delete">Delete</button>

            <div class="row curve-controls ofa-curve" style="gap:0px; margin-top:10px; align-items:center;">
              <button type="button" class="btn-sm js-curve-dec" aria-label="Curve minus">−</button>

              <div class="ofaCurveBar js-curve-bar" role="slider"
                   aria-valuemin="-300" aria-valuemax="300" aria-valuenow="${curveVal}"
                   tabindex="0"
                   data-value="${curveVal}">
                <div class="ofaCurveTrack"></div>
                <div class="ofaCurveTicks"></div>
                <div class="ofaCurveThumb" style="left:${curvePct}%"></div>
              </div>

              <button type="button" class="btn-sm js-curve-inc" aria-label="Curve plus">+</button>
              <button type="button" class="btn-sm js-curve-reset" title="Reset curve">⟷</button>
            </div>

          </div>
        </div>
      `;
    }

    function getObjById(fieldId) {
      return canvas.getObjects().find(o => {
        const id = (o.data && o.data.fieldId) ? o.data.fieldId : o._id;
        return id === fieldId;
      });
    }

    function getCardByObj(o) {
      if (!o) return null;
      const fieldId = (o.data && o.data.fieldId) ? o.data.fieldId : o._id;
      return fieldsRoot.querySelector(`.field[data-field-id="${CSS.escape(fieldId)}"]`);
    }

    function removeFieldForObject(o) {
      const card = getCardByObj(o);
      if (card) card.remove();
    }

    function highlightActive(o) {
      fieldsRoot.querySelectorAll(".field").forEach(el => el.classList.remove("active"));
      const card = getCardByObj(o);
      if (card) card.classList.add("active");
    }

    function syncPanelSelection(o) {
      highlightActive(o);

      if (o && o.type === "image" && o.data?.isLogo) {
        openImageEditor(o);
      } else {
        closeImageEditor();
      }
    }

    function renderPanel() {
      const prevScroll = fieldsRoot.scrollTop;

      const objs = canvas.getObjects()
        .filter(o =>
          o.type === "textbox" ||
          (o.data && o.data.isLogo) ||
          (o.data && o.data.isCurved)
        )
        .map(o => { ensurePanelOrder(o); return o; })
        .sort((a, b) => (a.data.panelOrder || 0) - (b.data.panelOrder || 0));

      fieldsRoot.innerHTML = objs.map(o => {
        if (o.data && o.data.isLogo) return cardHTMLLogo(o);
        return cardHTMLText(o);
      }).join("");

      wirePanel();
      highlightActive(canvas.getActiveObject());

      if (!__suppressPanelAutoScroll) fieldsRoot.scrollTop = prevScroll;
      if (addBtn) {
  const count = getTextFieldCount();
  addBtn.disabled = count >= MAX_TEXT_FIELDS;
}
    }

    /* ============================================
       IMAGE EDITOR PANEL (K2-like flow)
    ============================================ */
    let __activeImageEditorObj = null;

    function ensureImageEditorUI() {
      if (root.querySelector("[data-image-editor]")) return;

      const wrap = document.createElement("div");
      wrap.setAttribute("data-image-editor", "1");
      wrap.style.display = "none";
      wrap.style.margin = "10px 0";
      wrap.style.padding = "14px";
      wrap.style.background = "#d9d9d9";
      wrap.style.borderRadius = "10px";

      wrap.innerHTML = `
        <div style="display:flex;align-items:center;gap:12px;">
          <div data-image-thumb style="width:72px;height:48px;background:#fff;border-radius:6px;overflow:hidden;border:1px solid #cfcfcf;flex:0 0 auto;display:flex;align-items:center;justify-content:center;">
            <span style="font-size:12px;color:#666;">Image</span>
          </div>

          <div style="flex:1;">
            <div style="display:flex;align-items:center;gap:10px;">
              <div style="font-size:14px;font-weight:600;color:#222;">Image Contrast</div>
              <input data-image-contrast type="range" min="-100" max="100" value="0" style="flex:1;">
              <button type="button" data-image-delete title="Delete" style="border:0;background:transparent;font-size:18px;cursor:pointer;">🗑️</button>
            </div>

            <div style="display:flex;gap:10px;margin-top:10px;">
              <button type="button" data-image-invert class="btn-sm">Invert</button>
              <button type="button" data-image-center class="btn-sm">Center</button>
              <button type="button" data-image-replace class="btn-sm">Replace</button>
            </div>

            <button type="button" data-image-save class="btn-sm" style="width:100%;margin-top:12px;">Save</button>
          </div>
        </div>
      `;

      fieldsRoot.parentNode.insertBefore(wrap, fieldsRoot);

      const slider = wrap.querySelector("[data-image-contrast]");
      const btnInvert = wrap.querySelector("[data-image-invert]");
      const btnCenter = wrap.querySelector("[data-image-center]");
      const btnReplace = wrap.querySelector("[data-image-replace]");
      const btnDelete = wrap.querySelector("[data-image-delete]");
      const btnSave = wrap.querySelector("[data-image-save]");

      let __sliderRaf = null;

      slider.addEventListener("input", () => {
        if (!__activeImageEditorObj) return;
        if (__sliderRaf) cancelAnimationFrame(__sliderRaf);
        __sliderRaf = requestAnimationFrame(() => {
          const v = Number(slider.value || 0);
          setImageContrast(__activeImageEditorObj, v);
        });
      });

      btnInvert.addEventListener("click", (e) => {
        e.preventDefault();
        if (!__activeImageEditorObj) return;
        const cur = !!__activeImageEditorObj.data?.imgInvert;
        setImageInvert(__activeImageEditorObj, !cur);
        btnInvert.classList.toggle("is-active", !cur);
      });

      btnCenter.addEventListener("click", (e) => {
        e.preventDefault();
        if (!__activeImageEditorObj) return;

        __activeImageEditorObj.set({
          originX: "center",
          originY: "center",
          left: canvas.getWidth() / 2,
          top: canvas.getHeight() / 2
        });

        try { clampToCanvas(__activeImageEditorObj); } catch (err) {}
        __activeImageEditorObj.setCoords();
        canvas.requestRenderAll();
      });

      btnReplace.addEventListener("click", async (e) => {
        e.preventDefault();
        if (!__activeImageEditorObj) return;

        const current = __activeImageEditorObj;

        const input = document.createElement("input");
        input.type = "file";
        input.accept = "image/*";
        input.style.display = "none";
        document.body.appendChild(input);

        input.onchange = async () => {
          const file = input.files && input.files[0];
          if (!file) { document.body.removeChild(input); return; }

          try {
            const dataUrl = await fileToDataUrl(file);

            fabric.Image.fromURL(dataUrl, (newImg) => {
              if (!newImg) { document.body.removeChild(input); return; }

              newImg.set({
                left: current.left,
                top: current.top,
                originX: current.originX || "center",
                originY: current.originY || "center",
                angle: current.angle || 0,
                scaleX: current.scaleX || 1,
                scaleY: current.scaleY || 1,
                selectable: true,
                evented: true,
                hasControls: true,
                hasBorders: true
              });

              newImg.data = { ...(current.data || {}) };
              newImg.data.isLogo = true;
              newImg.data.fieldId = current.data?.fieldId || "logo";
              newImg.data.imgSrc = dataUrl;

              newImg.data.imgContrast = current.data?.imgContrast || 0;
              newImg.data.imgInvert = current.data?.imgInvert || false;

              attachControls(newImg);

              canvas.remove(current);
              canvas.add(newImg);
              canvas.setActiveObject(newImg);
              __activeImageEditorObj = newImg;

              applyImageFilters(newImg);
              canvas.requestRenderAll();
              renderPanel();
              openImageEditor(newImg);

              document.body.removeChild(input);
            }, { crossOrigin: "anonymous" });

          } catch (err) {
            console.error("Replace failed:", err);
            alert("Replace failed. Check console.");
            document.body.removeChild(input);
          }
        };

        input.click();
      });

      btnDelete.addEventListener("click", (e) => {
        e.preventDefault();
        if (!__activeImageEditorObj) return;

        canvas.remove(__activeImageEditorObj);
        canvas.discardActiveObject();
        canvas.requestRenderAll();
        closeImageEditor();
        renderPanel();
      });

      btnSave.addEventListener("click", (e) => {
        e.preventDefault();
        closeImageEditor();
        renderPanel();
      });
    }

    function openImageEditor(imgObj) {
      ensureImageEditorUI();
      const wrap = root.querySelector("[data-image-editor]");
      if (!wrap) return;

      __activeImageEditorObj = imgObj;

      wrap.style.display = "block";

      imgObj.data = imgObj.data || {};
      if (imgObj.data.imgContrast == null) imgObj.data.imgContrast = 0;
      if (imgObj.data.imgInvert == null) imgObj.data.imgInvert = false;

      const slider = wrap.querySelector("[data-image-contrast]");
      const btnInvert = wrap.querySelector("[data-image-invert]");
      const thumb = wrap.querySelector("[data-image-thumb]");

      slider.value = String(Number(imgObj.data.imgContrast || 0));
      btnInvert.classList.toggle("is-active", !!imgObj.data.imgInvert);

      if (thumb) {
        thumb.innerHTML = "";
        const src = imgObj.data.imgSrc;
        if (src) {
          const im = document.createElement("img");
          im.src = src;
          im.style.width = "100%";
          im.style.height = "100%";
          im.style.objectFit = "cover";
          thumb.appendChild(im);
        } else {
          thumb.innerHTML = `<span style="font-size:12px;color:#666;">Image</span>`;
        }
      }
    }

    function closeImageEditor() {
      const wrap = root.querySelector("[data-image-editor]");
      if (wrap) wrap.style.display = "none";
      __activeImageEditorObj = null;
    }

    function applyImageFilters(imgObj) {
      if (!imgObj || imgObj.type !== "image") return;

      imgObj.data = imgObj.data || {};
      const contrastVal = Number(imgObj.data.imgContrast || 0);
      const invertOn = !!imgObj.data.imgInvert;

      const contrast = Math.max(-1, Math.min(1, contrastVal / 100));
      const filters = [];

      filters.push(new fabric.Image.filters.Contrast({ contrast }));
      if (invertOn) filters.push(new fabric.Image.filters.Invert());

      imgObj.filters = filters;
      imgObj.applyFilters();
      imgObj.dirty = true;
      canvas.requestRenderAll();
    }

    function setImageContrast(imgObj, v) {
      if (!imgObj) return;
      imgObj.data = imgObj.data || {};
      imgObj.data.imgContrast = Number(v) || 0;
      applyImageFilters(imgObj);
    }

    function setImageInvert(imgObj, on) {
      if (!imgObj) return;
      imgObj.data = imgObj.data || {};
      imgObj.data.imgInvert = !!on;
      applyImageFilters(imgObj);
    }

    function wirePanel() {
      fieldsRoot.querySelectorAll(".field").forEach(card => {
        const id = card.getAttribute("data-field-id");
        const obj = getObjById(id);
        if (!obj) return;

        card.addEventListener("click", () => {
          const current = getObjById(id);
          if (current && canvas.getActiveObject() !== current) {
            canvas.setActiveObject(current);
            canvas.requestRenderAll();
            highlightActive(current);
          }
        });

        if (obj?.data?.isLogo) {
          const replaceBtn = card.querySelector(".js-logo-replace");
          const deleteBtn = card.querySelector(".js-logo-delete");

          replaceBtn?.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();

            const current = getObjById(id);
            if (!current) return;

            const input = document.createElement("input");
            input.type = "file";
            input.accept = "image/*";
            input.style.display = "none";
            document.body.appendChild(input);

            input.onchange = async () => {
              const file = input.files && input.files[0];
              if (!file) {
                document.body.removeChild(input);
                return;
              }

              try {
                const dataUrl = await fileToDataUrl(file);
                const processedPng = await preprocessImageToTransparentBW(dataUrl);

                fabric.Image.fromURL(processedPng, (newImg) => {
                  if (!newImg) {
                    document.body.removeChild(input);
                    return;
                  }

                  newImg.set({
                    left: current.left,
                    top: current.top,
                    originX: current.originX || "center",
                    originY: current.originY || "top",
                    angle: current.angle || 0,
                    selectable: true,
                    evented: true,
                    hasControls: true,
                    hasBorders: true
                  });

                  const targetW = current.getScaledWidth();
                  if (targetW) newImg.scaleToWidth(targetW);

                  newImg.data = { ...(current.data || {}) };
                  newImg.data.isLogo = true;
                  newImg.data.fieldId = current.data?.fieldId || "logo";

                  attachControls(newImg);

                  canvas.remove(current);
                  canvas.add(newImg);
                  canvas.setActiveObject(newImg);

                  try { clampScale(newImg); clampToCanvas(newImg); } catch (e) {}
                  canvas.requestRenderAll();
                  renderPanel();

                  document.body.removeChild(input);
                }, { crossOrigin: "anonymous" });

              } catch (err) {
                console.error("Replace logo failed:", err);
                alert("Replace logo failed. Check console.");
                document.body.removeChild(input);
              }
            };

            input.click();
          });

          deleteBtn?.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            const current = getObjById(id);
            if (!current) return;
            canvas.remove(current);
            canvas.discardActiveObject();
            canvas.requestRenderAll();
            renderPanel();
          });

          return;
        }

        const textArea = card.querySelector(".js-text");
        const fontSel = card.querySelector(".js-font");
        const sizeInput = card.querySelector(".js-size");
        const btnB = card.querySelector(".js-bold");
        const btnI = card.querySelector(".js-italic");
        const delBtn = card.querySelector(".js-delete");

        const curveBar = card.querySelector(".js-curve-bar");
        const curveReset = card.querySelector(".js-curve-reset");
        const curveDec = card.querySelector(".js-curve-dec");
        const curveInc = card.querySelector(".js-curve-inc");

        textArea?.addEventListener("input", (e) => {
          const val = e.target.value;
          const current = getObjById(id);
          if (!current) return;

          if (current.type === "textbox") {
            current.set({ text: val });
            current.dirty = true;
            current.initDimensions?.();
            current.setCoords?.();
            canvas.requestRenderAll();
            return;
          }

          if (current.data?.isCurved) {
            current.data.text = val;

            __isCurveAdjusting = true;
            try {
              applyCurveToObject(current, current.data.curve || 0);
            } finally {
              __isCurveAdjusting = false;
            }
          }
        });

        fontSel?.addEventListener("change", async () => {
          const current = getObjById(id);
          if (!current) return;
          const font = fontSel.value;

          if (current.type === "textbox") {
            current.set({ fontFamily: font });
            if (document.fonts?.load) {
              try {
                await document.fonts.load(`${Math.round(current.fontSize || 50)}px "${font}"`);
                await document.fonts.ready;
              } catch (e) {}
            }
            current.initDimensions?.();
            current.setCoords?.();
            try { clampToCanvas(current); } catch (e) {}
            canvas.requestRenderAll();
            return;
          }

          if (current.data?.isCurved) {
            current.data.fontFamily = font;
            applyCurveToObject(current, current.data.curve || 0);
          }
        });

        card.querySelector(".js-size-inc")?.addEventListener("click", () => {
          const current = getObjById(id);
          if (!current) return;

          const v = Math.min(200, (Number(sizeInput?.value) || getFontSize(current)) + 2);
          if (sizeInput) sizeInput.value = v;

          if (current.type === "textbox") {
            current.set({ fontSize: v });
            current.initDimensions?.();
            current.setCoords?.();
            canvas.requestRenderAll();
            return;
          }

          if (current.data?.isCurved) {
            current.data.fontSize = v;
            applyCurveToObject(current, current.data.curve || 0);
          }
        });

        card.querySelector(".js-size-dec")?.addEventListener("click", () => {
          const current = getObjById(id);
          if (!current) return;

          const v = Math.max(8, (Number(sizeInput?.value) || getFontSize(current)) - 2);
          if (sizeInput) sizeInput.value = v;

          if (current.type === "textbox") {
            current.set({ fontSize: v });
            current.initDimensions?.();
            current.setCoords?.();
            canvas.requestRenderAll();
            return;
          }

          if (current.data?.isCurved) {
            current.data.fontSize = v;
            applyCurveToObject(current, current.data.curve || 0);
          }
        });

        sizeInput?.addEventListener("change", () => {
          const current = getObjById(id);
          if (!current) return;

          const v = Math.max(8, Math.min(200, Number(sizeInput.value) || getFontSize(current)));
          sizeInput.value = v;

          if (current.type === "textbox") {
            current.set({ fontSize: v });
            current.initDimensions?.();
            current.setCoords?.();
            canvas.requestRenderAll();
            return;
          }

          if (current.data?.isCurved) {
            current.data.fontSize = v;
            applyCurveToObject(current, current.data.curve || 0);
          }
        });

        btnB?.addEventListener("click", () => {
          const current = getObjById(id);
          if (!current) return;

          const pressed = btnB.getAttribute("aria-pressed") === "true";
          btnB.setAttribute("aria-pressed", String(!pressed));
          const next = pressed ? "normal" : "bold";

          if (current.type === "textbox") {
            current.set({ fontWeight: next });
            current.initDimensions?.();
            current.setCoords?.();
            canvas.requestRenderAll();
            return;
          }
          if (current.data?.isCurved) {
            current.data.fontWeight = next;
            applyCurveToObject(current, current.data.curve || 0);
          }
        });

        btnI?.addEventListener("click", () => {
          const current = getObjById(id);
          if (!current) return;

          const pressed = btnI.getAttribute("aria-pressed") === "true";
          btnI.setAttribute("aria-pressed", String(!pressed));
          const next = pressed ? "normal" : "italic";

          if (current.type === "textbox") {
            current.set({ fontStyle: next });
            current.initDimensions?.();
            current.setCoords?.();
            canvas.requestRenderAll();
            return;
          }
          if (current.data?.isCurved) {
            current.data.fontStyle = next;
            applyCurveToObject(current, current.data.curve || 0);
          }
        });

        card.querySelectorAll(".js-align")?.forEach(btn => {
          btn.addEventListener("click", () => {
            const current = getObjById(id);
            if (!current) return;

            const align = btn.getAttribute("data-align") || "center";

            if (current.type === "textbox") {
              current.set({ textAlign: align });
              current.initDimensions?.();
              current.setCoords?.();
              canvas.requestRenderAll();
              return;
            }

            if (current.data?.isCurved) {
              current.data.textAlign = align;
              applyCurveToObject(current, current.data.curve || 0);
            }
          });
        });

        delBtn?.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          const current = getObjById(id);
          if (!current) return;
          canvas.remove(current);
          canvas.discardActiveObject();
          canvas.requestRenderAll();
          renderPanel();
        });

        function getLiveObj() {
          return getObjById(id);
        }

        function setCurveValue(next) {
          next = Math.max(-300, Math.min(300, Number(next) || 0));

          if (curveBar) {
            curveBar.dataset.value = String(next);
            curveBar.setAttribute("aria-valuenow", String(next));
            const pct = ((next + 300) / 600) * 100;
            const thumb = curveBar.querySelector(".ofaCurveThumb");
            if (thumb) thumb.style.left = pct + "%";
          }

          const live = getLiveObj();
          if (!live) return;

          __isCurveAdjusting = true;
          try {
            applyCurveToObject(live, next);
          } finally {
            __isCurveAdjusting = false;
          }
        }

        curveBar?.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();

          const rect = curveBar.getBoundingClientRect();
          const x = Math.max(0, Math.min(rect.width, e.clientX - rect.left));
          const ratio = rect.width ? (x / rect.width) : 0.5;

          const next = Math.round((-300 + ratio * 600) / 5) * 5;
          setCurveValue(next);
        });

        curveBar?.addEventListener("keydown", (e) => {
          const cur = Number(curveBar.dataset.value || 0);
          if (e.key === "ArrowLeft") { e.preventDefault(); setCurveValue(cur - 10); }
          if (e.key === "ArrowRight") { e.preventDefault(); setCurveValue(cur + 10); }
        });

        curveDec?.addEventListener("click", (e) => {
          e.preventDefault(); e.stopPropagation();
          const cur = Number(curveBar?.dataset.value || 0);
          setCurveValue(cur - 10);
        });

        curveInc?.addEventListener("click", (e) => {
          e.preventDefault(); e.stopPropagation();
          const cur = Number(curveBar?.dataset.value || 0);
          setCurveValue(cur + 10);
        });

        curveReset?.addEventListener("click", (e) => {
          e.preventDefault(); e.stopPropagation();
          setCurveValue(0);
        });
      });
    }

    // -----------------------------
    // Canvas events
    // -----------------------------
    canvas.on("selection:created", e => syncPanelSelection(e.selected && e.selected[0]));
    canvas.on("selection:updated", e => syncPanelSelection(e.selected && e.selected[0]));
    canvas.on("selection:cleared", () => syncPanelSelection(null));
    canvas.on("object:moving", e => clampToCanvas(e.target));
    canvas.on("object:scaling", e => { clampScale(e.target); clampToCanvas(e.target); });

    canvas.on("object:added", () => {
      if (__isCurveAdjusting) return;
      renderPanel();
    });
    canvas.on("object:removed", () => {
      if (__isCurveAdjusting) return;
      renderPanel();
    });

    const addBtn = root.querySelector("[data-add-text]");

addBtn?.addEventListener("click", () => {
  const currentCount = getTextFieldCount();

  if (currentCount >= MAX_TEXT_FIELDS) {
    alert(`You can only add up to ${MAX_TEXT_FIELDS} text lines.`);
    return;
  }

  const t = newTextbox("Enter Name Here");

  // Position below last text
  const texts = canvas.getObjects().filter(o =>
    o.type === "textbox" || (o.data && o.data.isCurved)
  );

  if (texts.length) {
    const last = texts[texts.length - 1];
    const newTop =
      (last.top || 0) +
      (last.getScaledHeight ? last.getScaledHeight() : 40) +
      20;

    t.set({ top: newTop });
  }

  canvas.add(t).setActiveObject(t);
  canvas.requestRenderAll();
  renderPanel();
});

    // -----------------------------
    // Hide/restore controls for preview exports
    // -----------------------------
    function hideFabricControls() {
      canvas.discardActiveObject();
      canvas.getObjects().forEach(o => {
        o._prevSelectable = o.selectable;
        o._prevEvented = o.evented;
        o.selectable = false;
        o.evented = false;
      });
      canvas.selection = false;
      canvas.requestRenderAll();
    }

    function restoreFabricControls() {
      canvas.getObjects().forEach(o => {
        if (o._prevSelectable !== undefined) {
          o.selectable = o._prevSelectable;
          o.evented = o._prevEvented;
          delete o._prevSelectable;
          delete o._prevEvented;
        }
      });
      canvas.selection = true;
      canvas.requestRenderAll();
    }

    // =========================================================
    // ✅ SVG WITH TEMPLATE BG SVG + TRUE CENTERING (FIXED)
    // =========================================================
    function buildSvgStringWithBg(bgSvgUrl) {
      const raw = canvas.toSVG({ suppressPreamble: false });

      const parser = new DOMParser();
      const doc = parser.parseFromString(raw, "image/svg+xml");
      if (doc.querySelector("parsererror")) return raw;

      const svg = doc.documentElement;

      const cw = Number(canvas.getWidth()) || 800;
      const ch = Number(canvas.getHeight()) || 800;

      const W = 900;
      const H = 360;

      const ns = "http://www.w3.org/2000/svg";
      const children = Array.from(svg.childNodes);
      const g = doc.createElementNS(ns, "g");
      children.forEach(n => g.appendChild(n));

      while (svg.firstChild) svg.removeChild(svg.firstChild);

      svg.setAttribute("width", String(W));
      svg.setAttribute("height", String(H));
      svg.setAttribute("viewBox", `0 0 ${W} ${H}`);

      const url = cleanUrl(bgSvgUrl || "");
      if (url) {
        const xlink = "http://www.w3.org/1999/xlink";
        const bg = doc.createElementNS(ns, "image");
        bg.setAttribute("x", "0");
        bg.setAttribute("y", "0");
        bg.setAttribute("width", String(W));
        bg.setAttribute("height", String(H));
        bg.setAttribute("preserveAspectRatio", "xMidYMid meet");
        bg.setAttribute("href", url);
        bg.setAttributeNS(xlink, "xlink:href", url);
        svg.appendChild(bg);
      }

      const s = Math.min(W / cw, H / ch);
      const tx = (W - cw * s) / 2;
      const ty = (H - ch * s) / 2;
      g.setAttribute("transform", `translate(${tx} ${ty}) scale(${s})`);
      svg.appendChild(g);

      svg.querySelectorAll("text, tspan").forEach(el => {
        el.setAttribute("fill", "#000000");
      });

      return new XMLSerializer().serializeToString(svg);
    }
// ✅ RAW SVG string for line item property (engravingSvgText)
function buildEngravingSvgText(bgSvgUrl) {
  const svg = buildSvgStringWithBg(bgSvgUrl);
  return String(svg)
    .replace(/\r?\n|\r/g, " ")
    .replace(/\s{2,}/g, " ")
    .trim();
}

    function buildSvgBlob(bgSvgUrl) {
      const out = buildSvgStringWithBg(bgSvgUrl);
      return new Blob([out], { type: "image/svg+xml;charset=utf-8" });
    }

    root.querySelector("[data-export-svg]")?.addEventListener("click", () => {
      const bg = root.getAttribute("data-active-bg-svg") || "";
      // ✅ RAW SVG TEXT property
const engravingSvgText = buildEngravingSvgText(bg);

// Option A (recommended): create/ensure hidden input for Shopify line item property
let svgTextInput = document.getElementById("engravingSvgText");
if (!svgTextInput) {
  svgTextInput = document.createElement("input");
  svgTextInput.type = "hidden";
  svgTextInput.id = "engravingSvgText";
  svgTextInput.name = "properties[Engraving SVG Text]";
  // attach to product form if possible
  const form =
    document.querySelector('[data-product-form] form') ||
    document.querySelector('form[action*="/cart/add"]') ||
    document.querySelector('form[action="/cart/add"]');
  (form || document.body).appendChild(svgTextInput);
}
svgTextInput.value = engravingSvgText;

      const out = buildSvgStringWithBg(bg);
      const blob = new Blob([out], { type: "image/svg+xml;charset=utf-8" });
      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "engraving.svg";
      a.click();

      URL.revokeObjectURL(url);
    });

    // -----------------------------
    // Export full preview PNG (html2canvas)
    // -----------------------------
    async function exportPNG() {
      const wrap = root.querySelector(".ecPreviewInner");
      if (!wrap) return alert(".ecPreviewInner not found");

      hideFabricControls();
      await new Promise(r => setTimeout(r, 50));

      try {
        const shotCanvas = await html2canvas(wrap, {
          scale: 2,
          useCORS: true,
          allowTaint: false,
          backgroundColor: null
        });

        const dataUrl = shotCanvas.toDataURL("image/png");
        const a = document.createElement("a");
        a.href = dataUrl;
        a.download = "engraving-full-preview.png";
        a.click();
      } catch (e) {
        console.error("Full preview export failed:", e);
        alert("Export failed. Check console.");
      } finally {
        restoreFabricControls();
      }
    }

    // -----------------------------
    // UPLOAD HELPERS (PNG + SVG + PDF)
    // -----------------------------
    const previewImgInput = document.getElementById("previewImg");
    const previewSvgInput = document.getElementById("previewSvg");
    const previewPdfInput = document.getElementById("previewPdf");

    const UPLOAD_ENDPOINT = "https://mdwillerco.com/api/";

    async function uploadToPhpstack(blobOrFile, filename) {
      const fd = new FormData();
      fd.append("file", blobOrFile, filename);

      const res = await fetch(UPLOAD_ENDPOINT, {
        method: "POST",
        body: fd
      });

      const text = await res.text();
      let json;
      try {
        json = JSON.parse(text);
      } catch (e) {
        console.error("Upload non-JSON response:", text);
        throw new Error("Upload failed: server did not return JSON");
      }

      if (!res.ok) {
        throw new Error(json?.error || `Upload failed (HTTP ${res.status})`);
      }

      if (json?.ok && json?.url) return json.url;
      throw new Error(json?.error || "Upload failed");
    }

    async function buildPreviewPngBlob() {
      const wrap = root.querySelector(".ecPreviewInner");
      if (!wrap) throw new Error(".ecPreviewInner not found");

      hideFabricControls();
      await new Promise(r => setTimeout(r, 60));

      try {
        const shotCanvas = await html2canvas(wrap, {
          scale: 2,
          useCORS: true,
          allowTaint: false,
          backgroundColor: null
        });

        return await new Promise((resolve) => {
          shotCanvas.toBlob((b) => resolve(b), "image/png", 1);
        });
      } finally {
        restoreFabricControls();
      }
    }

    function sanitizeText(s) {
      return String(s ?? "").replace(/\s+/g, " ").trim();
    }

    function extractPropsFromFabricJson(fabricJson) {
      const out = [];
      const objects = fabricJson?.objects || [];

      for (const o of objects) {
        if (o.type === "textbox") {
          const id = o.data?.fieldId || o._id || "";
          const label = o._label || id || "Text";
          const value = sanitizeText(o.text || "");
          out.push({ name: label, value });
        }

        if (o.type === "image" && o.data?.isLogo) {
          const id = o.data?.fieldId || "logo";
          out.push({ name: id, value: "Logo/Image added" });
        }

        if (o.type === "group" && o.data?.isCurved) {
          const id = o.data?.fieldId || "curved_text";
          const label = o._label || id;
          const value = sanitizeText(o.data?.text || "");
          out.push({ name: label, value });
        }
      }

      return out;
    }

    async function buildPdfBlobFromAllPages() {
      if (!window.jspdf?.jsPDF) throw new Error("jsPDF not loaded");
      const { jsPDF } = window.jspdf;

      saveActivePage();

      const pdf = new jsPDF({ unit: "pt", format: "a4" });
      const pageW = pdf.internal.pageSize.getWidth();
      const pageH = pdf.internal.pageSize.getHeight();

      const margin = 40;
      let y = margin;

      const lineH = 16;
      const titleH = 22;

      function newPageIfNeeded(extra = lineH) {
        if (y + extra > pageH - margin) {
          pdf.addPage();
          y = margin;
          return true;
        }
        return false;
      }

      for (let i = 0; i < pageState.qty; i++) {
        if (i > 0) {
          pdf.addPage();
          y = margin;
        }

        const p = pageState.pages[i];
        const fabricJson = p?.json || null;

        pdf.setFont("helvetica", "bold");
        pdf.setFontSize(14);
        pdf.text(`Engraving Details`, margin, y);
        y += titleH;

        pdf.setFont("helvetica", "normal");
        pdf.setFontSize(11);
        pdf.text(`Item ${i + 1} of ${pageState.qty}`, margin, y);
        y += 18;

        pdf.setLineWidth(0.5);
        pdf.line(margin, y, pageW - margin, y);
        y += 14;

        if (!fabricJson) {
          pdf.setFontSize(11);
          pdf.text("No engraving data found for this item.", margin, y);
          y += lineH;
          continue;
        }

        const props = extractPropsFromFabricJson(fabricJson);

        if (!props.length) {
          pdf.text("No engraving fields found.", margin, y);
          y += lineH;
          continue;
        }

        pdf.setFont("helvetica", "normal");
        pdf.setFontSize(11);

        for (const row of props) {
          const name = sanitizeText(row.name || "Field");
          const value = sanitizeText(row.value || "");
          const left = `${name}: `;
          const maxWidth = pageW - margin * 2;

          const lines = pdf.splitTextToSize(left + value, maxWidth);

          newPageIfNeeded(lines.length * lineH + 6);
          pdf.text(lines, margin, y);
          y += lines.length * lineH + 6;
        }
      }

      return pdf.output("blob");
    }

    // ✅ NEW: split-mode single-page PDF
    async function buildPdfBlobForSinglePage(pageIndex, fabricJson) {
      if (!window.jspdf?.jsPDF) throw new Error("jsPDF not loaded");
      const { jsPDF } = window.jspdf;

      const pdf = new jsPDF({ unit: "pt", format: "a4" });
      const pageW = pdf.internal.pageSize.getWidth();
      const pageH = pdf.internal.pageSize.getHeight();

      const margin = 40;
      let y = margin;
      const lineH = 16;
      const titleH = 22;

      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(14);
      pdf.text(`Engraving Details`, margin, y);
      y += titleH;

      pdf.setFont("helvetica", "normal");
      pdf.setFontSize(11);
      pdf.text(`Item ${pageIndex + 1} of ${pageState.qty}`, margin, y);
      y += 18;

      pdf.setLineWidth(0.5);
      pdf.line(margin, y, pageW - margin, y);
      y += 14;

      if (!fabricJson) {
        pdf.setFontSize(11);
        pdf.text("No engraving data found for this item.", margin, y);
        return pdf.output("blob");
      }

      const props = extractPropsFromFabricJson(fabricJson);

      if (!props.length) {
        pdf.text("No engraving fields found.", margin, y);
        return pdf.output("blob");
      }

      pdf.setFont("helvetica", "normal");
      pdf.setFontSize(11);

      for (const row of props) {
        const name = sanitizeText(row.name || "Field");
        const value = sanitizeText(row.value || "");
        const left = `${name}: `;
        const maxWidth = pageW - margin * 2;

        const lines = pdf.splitTextToSize(left + value, maxWidth);

        if (y + lines.length * lineH + 6 > pageH - margin) {
          pdf.addPage();
          y = margin;
        }

        pdf.text(lines, margin, y);
        y += lines.length * lineH + 6;
      }

      return pdf.output("blob");
    }

    // ✅ NEW: Split helpers
    function sleep(ms) {
      return new Promise((r) => setTimeout(r, ms));
    }

    async function waitCanvasReady(maxMs = 1200) {
      const start = Date.now();
      while (Date.now() - start < maxMs) {
        if (canvas.getObjects().length) return;
        await sleep(30);
      }
    }

    function getVariantIdFromForm() {
      const form =
        document.querySelector(`[data-product-form] form`) ||
        document.querySelector('form[action*="/cart/add"]') ||
        document.querySelector('form[action="/cart/add"]');
      const idEl = form?.querySelector('input[name="id"]');
      return idEl?.value ? String(idEl.value) : "";
    }

    function getNotesValue() {
      const el = document.querySelector(".popup_notes");
      return el?.value ? String(el.value) : "";
    }

    async function handleSaveAndUpload(e) {
      e.preventDefault();

      const btn = e.currentTarget;
      btn.disabled = true;
      btn.classList.add("is-loading");

      try {
        saveActivePage();

        const bg = root.getAttribute("data-active-bg-svg") || "";

        // ==========================
        // ✅ BULK MODE
        // ==========================
        if (isBulkMode()) {
          syncQtyNameAttrForMode();

          const [pngBlob, svgBlob, pdfBlob] = await Promise.all([
            buildPreviewPngBlob(),
            Promise.resolve(buildSvgBlob(bg)),
            buildPdfBlobFromAllPages()
          ]);

          const [pngUrl, svgUrl, pdfUrl] = await Promise.all([
            uploadToPhpstack(pngBlob, `engraving-preview-${Date.now()}.png`),
            uploadToPhpstack(svgBlob, `engraving-vector-${Date.now()}.svg`),
            uploadToPhpstack(pdfBlob, `engraving-${Date.now()}.pdf`)
          ]);

          if (previewImgInput) previewImgInput.value = pngUrl;
          if (previewSvgInput) previewSvgInput.value = svgUrl;
          if (previewPdfInput) previewPdfInput.value = pdfUrl;

          const formId = btn.getAttribute("form");
          const form =
            (formId && document.querySelector(`form#${CSS.escape(formId)}`)) ||
            (formId && document.querySelector(`form[id="${formId}"]`)) ||
            document.querySelector('form[action*="/cart/add"]');

          if (!form) throw new Error("Add-to-cart form not found.");

          setTimeout(() => form.submit(), 150);

          document.getElementById("proofPopup")?.classList.add("is-hidden");
          document.getElementById("cartLoader")?.classList.add("is-active");
          return;
        }

        // ==========================
        // ✅ SPLIT MODE
        // ==========================
        syncQtyNameAttrForMode();

        const variantId = getVariantIdFromForm();
        if (!variantId) throw new Error("Variant ID not found in product form (input[name='id']).");

        document.getElementById("proofPopup")?.classList.add("is-hidden");
        document.getElementById("cartLoader")?.classList.add("is-active");

        const items = [];

        for (let i = 0; i < pageState.qty; i++) {
          setActivePage(i);
          await waitCanvasReady(1500);
          await sleep(80);

          saveActivePage();

          const p = pageState.pages[i];
          const fabricJson = p?.json || safeJSON();
          // ✅ RAW SVG TEXT for this item
const engravingSvgText = buildEngravingSvgText(bg);


          const [pngBlob, svgBlob, pdfBlob] = await Promise.all([
            buildPreviewPngBlob(),
            Promise.resolve(buildSvgBlob(bg)),
            buildPdfBlobForSinglePage(i, fabricJson)
            
          ]);

          const stamp = Date.now() + "-" + i;

          const [pngUrl, svgUrl, pdfUrl] = await Promise.all([
            uploadToPhpstack(pngBlob, `engraving-preview-${stamp}.png`),
            uploadToPhpstack(svgBlob, `engraving-vector-${stamp}.svg`),
            uploadToPhpstack(pdfBlob, `engraving-${stamp}.pdf`)
          ]);

          const props = extractPropsFromFabricJson(fabricJson);
          const properties = {};

          props.forEach((r) => {
            const k = sanitizeText(r.name || "");
            if (!k) return;
            properties[k] = sanitizeText(r.value || "");
          });

          properties["Engraving Preview URL"] = pngUrl;
          properties["SVG"] = svgUrl;
          properties["Engraving PDF URL"] = pdfUrl;
          // ✅ add RAW SVG text to this line item
        properties["SVG-Text"] = engravingSvgText;

          properties["Item #"] = String(i + 1);

          const notes = sanitizeText(getNotesValue());
          if (notes) properties["Notes"] = notes;

          items.push({
            id: Number(variantId),
            quantity: 1,
            properties
          });
        }

        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items })
        });

        if (!res.ok) {
          const t = await res.text();
          throw new Error("Cart add failed: " + t);
        }

        window.location.href = "/cart";

      } catch (err) {
        console.error(err);
        alert("Upload failed: " + (err.message || err));
        btn.disabled = false;
        btn.classList.remove("is-loading");
        document.getElementById("cartLoader")?.classList.remove("is-active");
      }
    }

    document.addEventListener("click", (e) => {
      const btn = e.target.closest(".ofaSave");
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      handleSaveAndUpload({
        preventDefault() { },
        currentTarget: btn
      });
    });

    root.querySelector("[data-export-json]")?.addEventListener("click", () => {
      const json = JSON.stringify(canvas.toJSON(), null, 2);
      const blob = new Blob([json], { type: "application/json" });
      const url = URL.createObjectURL(blob);
      window.open(url, "_blank");
    });

    // -----------------------------
    // DOCX export (optional, kept)
    // -----------------------------
    function collectFields() {
      return canvas.getObjects().filter(o => o.type === "textbox").map(o => ({
        id: o._id || "",
        text: o.text || "",
        fontFamily: o.fontFamily || "",
        fontSize: Math.round(o.fontSize || 0),
        fontWeight: (o.fontWeight || "normal") + "",
        fontStyle: (o.fontStyle || "normal") + "",
        textAlign: o.textAlign || "",
        left: Math.round(o.left || 0),
        top: Math.round(o.top || 0),
        width: Math.round((o.width || 0) * (o.scaleX || 1)),
        height: Math.round((o.height || 0) * (o.scaleY || 1))
      }));
    }

    function dataURLToUint8Array(dataURL) {
      const base64 = dataURL.split(",")[1];
      const bin = atob(base64);
      const bytes = new Uint8Array(bin.length);
      for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
      return bytes;
    }

    root.querySelector("[data-export-docx]")?.addEventListener("click", async () => {
      if (!window.docx) { alert("docx library not loaded"); return; }

      const {
        Document, Packer, Paragraph, HeadingLevel, Table, TableRow, TableCell,
        WidthType, TextRun, AlignmentType, ImageRun, BorderStyle
      } = window.docx;

      const fields = collectFields();

      const proofDataURL = canvas.toDataURL({ format: "png", multiplier: 2 });
      const proofBytes = dataURLToUint8Array(proofDataURL);

      const cellBorders = {
        top: { style: BorderStyle.SINGLE, size: 1, color: "CCCCCC" },
        bottom: { style: BorderStyle.SINGLE, size: 1, color: "CCCCCC" },
        left: { style: BorderStyle.SINGLE, size: 1, color: "CCCCCC" },
        right: { style: BorderStyle.SINGLE, size: 1, color: "CCCCCC" }
      };

      const colSizes = [12, 28, 10, 8, 8, 8, 8, 6, 6, 6, 6];
      const headers = ["ID", "Text", "Font", "Size", "Weight", "Style", "Align", "X", "Y", "W", "H"];

      const headerRow = new TableRow({
        children: headers.map((h, i) =>
          new TableCell({
            children: [new Paragraph({ text: h })],
            shading: { fill: "EDEFF3" },
            borders: cellBorders,
            width: { size: colSizes[i], type: WidthType.PERCENTAGE }
          })
        )
      });

      const bodyRows = fields.map(f =>
        new TableRow({
          children: [
            f.id, f.text, f.fontFamily, String(f.fontSize), f.fontWeight, f.fontStyle, f.textAlign,
            String(f.left), String(f.top), String(f.width), String(f.height)
          ].map((val, i) =>
            new TableCell({
              children: [new Paragraph({ text: String(val || "") })],
              borders: cellBorders,
              width: { size: colSizes[i], type: WidthType.PERCENTAGE }
            })
          )
        })
      );

      const table = new Table({
        width: { size: 100, type: WidthType.PERCENTAGE },
        rows: [headerRow, ...bodyRows]
      });

      const title = new Paragraph({
        text: "Engraving Customizer – Export",
        heading: HeadingLevel.TITLE,
        alignment: AlignmentType.LEFT
      });

      const note = new Paragraph({
        children: [
          new TextRun({ text: "Generated in browser. Fields reflect current canvas text objects.", size: 22, color: "666666" })
        ]
      });

      const proofHeading = new Paragraph({
        children: [new TextRun({ text: "Proof Image", bold: true })]
      });

      const proofImage = new Paragraph({
        children: [
          new ImageRun({
            data: proofBytes,
            transformation: { width: 720, height: Math.round(720 * (canvas.getHeight() / canvas.getWidth())) }
          })
        ]
      });

      const jsonTitle = new Paragraph({ children: [new TextRun({ text: "Raw JSON:", bold: true })] });
      const jsonBlock = new Paragraph({ children: [new TextRun({ text: JSON.stringify(canvas.toJSON(["data", "_id", "_label"]), null, 2) })] });

      const doc = new Document({
        sections: [{
          properties: { page: { margin: { top: 720, right: 720, bottom: 720, left: 720 } } },
          children: [title, note, table, proofHeading, proofImage, jsonTitle, jsonBlock]
        }]
      });

      const blob = await Packer.toBlob(doc);
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url; a.download = "engraving-export.docx"; a.click();
      URL.revokeObjectURL(url);
    });

    root.querySelector("[data-ec-back]")?.addEventListener("click", () => window.history.back());
    root.querySelector("[data-ec-close]")?.addEventListener("click", () => {
      document.querySelector('.ofa-customizer')?.classList.remove('show');
      unlockScroll();
    });

    // -----------------------------
    // Upload Image -> BW + Transparent background -> Add to Fabric
    // -----------------------------
    const uploadBtn = root.querySelector("[data-upload-image]");
    const uploadInput = root.querySelector("[data-upload-input]");

    const fileInput = uploadInput || (function createHiddenInput() {
      const inp = document.createElement("input");
      inp.type = "file";
      inp.accept = "image/*";
      inp.hidden = true;
      inp.setAttribute("data-upload-input", "");
      root.appendChild(inp);
      return inp;
    })();

    const REMOVE_WHITE_THRESHOLD = 235;
    const ALPHA_SOFTNESS = 20;

    // Tune these:
    const BG_TOL = 45;
    const FEATHER = 20;
    const FORCE_BW = true;

    function clamp01(n) { return Math.max(0, Math.min(1, n)); }

    async function preprocessImageToTransparentBW(dataUrl) {
      const img = await new Promise((resolve, reject) => {
        const im = new Image();
        im.onload = () => resolve(im);
        im.onerror = reject;
        im.src = dataUrl;
      });

      const c = document.createElement("canvas");
      const ctx = c.getContext("2d", { willReadFrequently: true });
      c.width = img.naturalWidth || img.width;
      c.height = img.naturalHeight || img.height;
      ctx.drawImage(img, 0, 0);

      const id = ctx.getImageData(0, 0, c.width, c.height);
      const d = id.data;
      const W = c.width, H = c.height;

      function dist(i, br, bg, bb) {
        const r = d[i], g = d[i + 1], b = d[i + 2];
        const dr = r - br, dg = g - bg, db = b - bb;
        return Math.sqrt(dr * dr + dg * dg + db * db);
      }

      let sr = 0, sg = 0, sb = 0, n = 0;
      const step = Math.max(1, Math.floor(Math.min(W, H) / 200));
      for (let x = 0; x < W; x += step) {
        let i1 = (0 * W + x) * 4;
        let i2 = ((H - 1) * W + x) * 4;
        sr += d[i1]; sg += d[i1 + 1]; sb += d[i1 + 2]; n++;
        sr += d[i2]; sg += d[i2 + 1]; sb += d[i2 + 2]; n++;
      }
      for (let y = 0; y < H; y += step) {
        let i1 = (y * W + 0) * 4;
        let i2 = (y * W + (W - 1)) * 4;
        sr += d[i1]; sg += d[i1 + 1]; sb += d[i1 + 2]; n++;
        sr += d[i2]; sg += d[i2 + 1]; sb += d[i2 + 2]; n++;
      }
      const br = sr / n, bg = sg / n, bb = sb / n;

      const visited = new Uint8Array(W * H);
      const bgMask = new Uint8Array(W * H);

      function pushIfBg(x, y, stack) {
        const idx = y * W + x;
        if (visited[idx]) return;
        visited[idx] = 1;
        const i = idx * 4;
        if (d[i + 3] === 0) {
          bgMask[idx] = 1;
          stack.push(idx);
          return;
        }
        if (dist(i, br, bg, bb) <= BG_TOL) {
          bgMask[idx] = 1;
          stack.push(idx);
        }
      }

      const stack = [];
      for (let x = 0; x < W; x++) {
        pushIfBg(x, 0, stack);
        pushIfBg(x, H - 1, stack);
      }
      for (let y = 0; y < H; y++) {
        pushIfBg(0, y, stack);
        pushIfBg(W - 1, y, stack);
      }

      while (stack.length) {
        const idx = stack.pop();
        const x = idx % W;
        const y = (idx / W) | 0;

        if (x > 0) pushIfBg(x - 1, y, stack);
        if (x < W - 1) pushIfBg(x + 1, y, stack);
        if (y > 0) pushIfBg(x, y - 1, stack);
        if (y < H - 1) pushIfBg(x, y + 1, stack);
      }

      for (let y = 0; y < H; y++) {
        for (let x = 0; x < W; x++) {
          const idx = y * W + x;
          const i = idx * 4;

          if (FORCE_BW) {
            const r = d[i], g2 = d[i + 1], b2 = d[i + 2];
            const gray = Math.round(0.299 * r + 0.587 * g2 + 0.114 * b2);
            d[i] = gray; d[i + 1] = gray; d[i + 2] = gray;
          }

          if (!bgMask[idx]) continue;

          const delta = dist(i, br, bg, bb);
          let a = 255;

          if (delta <= BG_TOL) a = 0;
          else if (FEATHER > 0 && delta < BG_TOL + FEATHER) {
            a = Math.round(255 * clamp01((delta - BG_TOL) / FEATHER));
          }

          d[i + 3] = Math.min(d[i + 3], a);
        }
      }

      ctx.putImageData(id, 0, 0);
      return c.toDataURL("image/png");
    }

    async function addUploadedImageToCanvas(file) {
      const dataUrl = await new Promise((resolve, reject) => {
        const fr = new FileReader();
        fr.onload = () => resolve(fr.result);
        fr.onerror = reject;
        fr.readAsDataURL(file);
      });

      const processedPng = await preprocessImageToTransparentBW(dataUrl);

      return new Promise((resolve) => {
        fabric.Image.fromURL(processedPng, (img) => {
          if (!img) return resolve(null);

          img.set({
            originX: "center",
            originY: "center",
            left: canvas.getWidth() / 2,
            top: canvas.getHeight() / 2,
            selectable: true,
            evented: true
          });

          const targetW = canvas.getWidth() * 0.6;
          if (img.width) img.scaleToWidth(targetW);

          img.data = img.data || {};
          img.data.isLogo = true;
          img.data.fieldId = `upload_logo_${Date.now()}`;

          attachControls(img);

          canvas.add(img);
          canvas.setActiveObject(img);

          try { clampScale(img); clampToCanvas(img); } catch (e) { }

          canvas.requestRenderAll();
          renderPanel();

          resolve(img);
        }, { crossOrigin: "anonymous" });
      });
    }

    if (uploadBtn) {
      uploadBtn.addEventListener("click", () => {
        fileInput.value = "";
        fileInput.click();
      });
    }

    fileInput.addEventListener("change", async () => {
      const file = fileInput.files && fileInput.files[0];
      if (!file) return;

      try {
        await addUploadedImageToCanvas(file);
      } catch (err) {
        console.error("Upload image failed:", err);
        alert("Image upload failed. Check console.");
      }
    });

    // -----------------------------
    // POPULAR IMAGES -> add to canvas (transparent + recolor)
    // -----------------------------
    const popularBtn = root.querySelector("[data-popular-images]");
    const popWrap = root.querySelector("[data-popular-images-popup]");
    const popClose = root.querySelector("[data-popular-images-close]");

    function openPopular() { popWrap?.classList.add("active"); }
    function closePopular() { popWrap?.classList.remove("active"); }

    popularBtn?.addEventListener("click", openPopular);
    popClose?.addEventListener("click", closePopular);
    popWrap?.addEventListener("click", (e) => { if (e.target === popWrap) closePopular(); });

    function getActiveTextColor() {
      const o = canvas.getActiveObject();
      if (o && o.type === "textbox" && o.fill) return String(o.fill);
      const t = canvas.getObjects().find(x => x.type === "textbox" && x.fill);
      if (t) return String(t.fill);
      return "#ffffff";
    }

    function hexToRgb(hex) {
      let h = String(hex || "#ffffff").replace("#", "").trim();
      if (h.length === 3) h = h.split("").map(ch => ch + ch).join("");
      if (h.length !== 6) return null;
      const n = parseInt(h, 16);
      return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
    }

    async function preprocessImageTransparentAndRecolor(dataUrl, targetHex) {
      const img = await new Promise((resolve, reject) => {
        const im = new Image();
        im.crossOrigin = "anonymous";
        im.onload = () => resolve(im);
        im.onerror = reject;
        im.src = dataUrl;
      });

      const c = document.createElement("canvas");
      const ctx = c.getContext("2d", { willReadFrequently: true });

      c.width = img.naturalWidth || img.width;
      c.height = img.naturalHeight || img.height;
      ctx.drawImage(img, 0, 0);

      const id = ctx.getImageData(0, 0, c.width, c.height);
      const d = id.data;

      const thr = REMOVE_WHITE_THRESHOLD;
      const soft = Math.max(0, ALPHA_SOFTNESS);

      const rgb = hexToRgb(targetHex) || { r: 255, g: 255, b: 255 };

      for (let i = 0; i < d.length; i += 4) {
        const r = d[i], g = d[i + 1], b = d[i + 2];
        const gray = Math.round(0.299 * r + 0.587 * g + 0.114 * b);

        let a = 255;
        if (gray >= thr) a = 0;
        else if (soft > 0 && gray >= (thr - soft)) {
          const t = (thr - gray) / soft;
          a = Math.round(255 * clamp01(t));
        }

        const strength = 1 - (gray / 255);
        d[i] = Math.round(rgb.r * strength + 255 * (1 - strength));
        d[i + 1] = Math.round(rgb.g * strength + 255 * (1 - strength));
        d[i + 2] = Math.round(rgb.b * strength + 255 * (1 - strength));
        d[i + 3] = Math.min(d[i + 3], a);
      }

      ctx.putImageData(id, 0, 0);
      return c.toDataURL("image/png");
    }

    async function addPopularImageToCanvas(url, fieldId = "popular_image") {
      const rawDataUrl = await new Promise((resolve, reject) => {
        const im = new Image();
        im.crossOrigin = "anonymous";
        im.onload = () => {
          const c = document.createElement("canvas");
          c.width = im.naturalWidth || im.width;
          c.height = im.naturalHeight || im.height;
          const ctx = c.getContext("2d");
          ctx.drawImage(im, 0, 0);
          resolve(c.toDataURL("image/png"));
        };
        im.onerror = reject;
        im.src = url;
      });

      const color = getActiveTextColor();
      const processed = await preprocessImageTransparentAndRecolor(rawDataUrl, color);

      return new Promise((resolve) => {
        fabric.Image.fromURL(processed, (img) => {
          if (!img) return resolve(null);

          img.set({
            originX: "center",
            originY: "center",
            left: canvas.getWidth() / 2,
            top: canvas.getHeight() / 2,
            selectable: true,
            evented: true,
            hasControls: true,
            hasBorders: true
          });

          const targetW = canvas.getWidth() * 0.6;
          if (img.width) img.scaleToWidth(targetW);

          img.data = img.data || {};
          img.data.isLogo = true;
          img.data.fieldId = `${fieldId}_${Date.now()}`;

          attachControls(img);

          canvas.add(img);
          canvas.setActiveObject(img);

          try { clampScale(img); clampToCanvas(img); } catch (e) { }

          canvas.requestRenderAll();
          renderPanel();

          resolve(img);
        }, { crossOrigin: "anonymous" });
      });
    }

    popWrap?.addEventListener("click", async (e) => {
      const li = e.target.closest(".popular-images__item");
      if (!li) return;

      const url = li.getAttribute("data-image-url");
      if (!url) return;

      try {
        await addPopularImageToCanvas(url, "popular");
        closePopular();
      } catch (err) {
        console.error("Popular image add failed:", err);
        alert("Could not add image. Check console.");
      }
    });

    // -----------------------------
    // Default template load from attribute (optional)
    // -----------------------------
    const defaultJsonStr = root.getAttribute("data-default-template-json");
    if (defaultJsonStr) {
      try {
        const tpl = JSON.parse(decodeHtmlEntities(defaultJsonStr));
        applyTemplateFromJSON(tpl);
      } catch (e) {
        console.warn("Default template JSON parse failed:", e);
        renderPanel();
      }
    } else {
      renderPanel();
    }

    console.log("✅ Engrave initApp mounted", root);
  }
})();

/* =========================================================
   Template Grid + Drawer + Overlay logic
========================================================= */
document.addEventListener("DOMContentLoaded", () => {
  const btnDesignOnline = document.querySelector("[btn-open-customizer]");
  const btnPersonalize = document.querySelector("[btn-personalize]");
  const sideDrawer = document.querySelector(".sideDrawer");

  const templateDrawer = document.querySelector(".templateDrawer") || document.querySelector("#templateDrawer");

  const customizerOverlay = document.getElementById("ofaCustomizer");
  const ofaClose = document.getElementById("ofaClose");

  const lockScroll = () => { document.documentElement.style.overflow = "hidden"; };
  // const unlockScroll = () => { document.documentElement.style.overflow = ""; };

  function openSideDrawer() { sideDrawer?.classList.add("active"); }
  function closeSideDrawer() { sideDrawer?.classList.remove("active"); }

  function openTemplateDrawer() {
    if (!templateDrawer) return;
    templateDrawer.classList.add("is-open");
    templateDrawer.setAttribute("aria-hidden", "false");
    lockScroll();
  }
  function closeTemplateDrawer() {
    if (!templateDrawer) return;
    templateDrawer.classList.remove("is-open");
    templateDrawer.setAttribute("aria-hidden", "true");
    unlockScroll();
  }

  function openCustomizer() {
    if (!customizerOverlay) return;
    customizerOverlay.classList.add("show");
    lockScroll();
  }
  function closeCustomizer() {
    if (!customizerOverlay) return;
    customizerOverlay.classList.remove("show");
    unlockScroll();
  }

  if (btnPersonalize && sideDrawer) {
    btnPersonalize.addEventListener("click", (e) => {
      e.preventDefault();
      openSideDrawer();
    });
  }

  if (btnDesignOnline) {
    btnDesignOnline.addEventListener("click", (e) => {
      e.preventDefault();
      closeSideDrawer();
      openTemplateDrawer();
    });
  }

  if (ofaClose && customizerOverlay) {
    ofaClose.addEventListener("click", (e) => {
      e.preventDefault();
      closeCustomizer();
    });
  }

  function decodeHtmlEntities(str) {
    return String(str || "")
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .replace(/&amp;/g, "&");
  }

  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-template]");
    if (!btn) return;

    const img = btn.getAttribute("data-template-image");
    const bgSvg = btn.getAttribute("data-template-bg-svg");

    const jsonNode = btn.querySelector('script[type="application/json"][data-template-json]');
    if (!jsonNode) return;

    let tpl;
    try {
      const raw = jsonNode.textContent.trim();
      const decoded = decodeHtmlEntities(raw);
      tpl = JSON.parse(decoded);
    } catch (err) {
      console.error("Template JSON parse failed:", err);
      return;
    }

    closeTemplateDrawer();
    openCustomizer();

    const appRoot = document.querySelector("[data-engrave-app]");
    if (appRoot) {
      appRoot.setAttribute("data-active-bg-svg", bgSvg || "");
      appRoot.setAttribute("data-active-bg-image", img || "");
    }

    const rootEl = appRoot || document.querySelector("[data-engrave-app]");
    if (rootEl && img) {
      if (window.ofaSetCustomizerBackground) {
        window.ofaSetCustomizerBackground(img);
      } else {
        const preview =
          document.querySelector("#ofaCustomizer .ecPreviewInner") ||
          document.querySelector(".ecPreviewInner") ||
          document.querySelector("#ofaCustomizer [data-stage]");

        if (preview) {
          preview.style.width = "900px";
          preview.style.height = "360px";
          preview.style.setProperty("background-image", `url("${img}")`, "important");
          preview.style.setProperty("background-repeat", "no-repeat", "important");
          preview.style.setProperty("background-position", "center", "important");
          preview.style.setProperty("background-size", "700px 700px", "important");
        }
      }
    }

    window.ofaApplyTemplateJSON?.(tpl);
  });
});

/* =========================================================
   Proof popup + notes + template close + drawer close
========================================================= */
document.addEventListener('DOMContentLoaded', () => {
  let pop = document.querySelector('[proof_popup_open]');
  let popupWrapper = document.querySelector('#proofPopup');
  let dataAcclose  = document.querySelector("[data-ec-close]");
  let mainNotesPop = document.querySelector('.notes_popup');
  let notesBtn = document.querySelector('[data-notes]');
  let notesSave = document.querySelector('.btn_save_popup');
  let closeNotes = document.querySelector('.btn_cancel_popup');
  let closeSvg = document.querySelector('.popup_close');

  let templateClose = document.querySelector('[data-close-templates]');
  let template = document.querySelector('#templateDrawer') || document.querySelector('.templateDrawer');

  let mainDrawerClose = document.querySelector('.close_icon');
  let mainDrawer = document.querySelector('.sideDrawer');

  const unlockScroll = () => { document.documentElement.style.overflow = ""; };

  if (pop && popupWrapper) {
    pop.addEventListener('click', () => {
      popupWrapper.classList.remove('is-hidden');
    });
  }

  if (notesBtn && mainNotesPop) {
    notesBtn.addEventListener('click', () => {
      mainNotesPop.style.display = "flex";
    });
  }

  if (notesSave) {
    notesSave.addEventListener('click', () => {
      let notesValue = document.querySelector('.notes');
      let notesSaveValue = document.querySelector('.popup_notes');
      if (notesSaveValue && notesValue) notesSaveValue.value = notesValue.value;
      if (mainNotesPop) mainNotesPop.style.display = "none";
    });
  }

  if (closeNotes && mainNotesPop) {
    closeNotes.addEventListener('click', () => {
      mainNotesPop.style.display = "none";
    });
  }

  if (closeSvg && mainNotesPop) {
    closeSvg.addEventListener('click', () => {
      mainNotesPop.style.display = "none";
    });
  }

  if (templateClose && template) {
    templateClose.addEventListener('click', () => {
      template.classList.remove('is-open');
      unlockScroll();
    });
  }
  if (dataAcclose) {
    dataAcclose.addEventListener("click", () => {
      unlockScroll();
    });
  }

  if (mainDrawerClose && mainDrawer) {
    mainDrawerClose.addEventListener('click', () => {
      mainDrawer.classList.remove('active');
    });
  }
});

/* =========================================================
   Shopify Variant Option → Toggle "Custom Logo" upload field
========================================================= */
(function () {
  const LEGEND_LABEL = window.__Option;
  const UPLOAD_WRAP_ID = "custom-logo-upload-wrap";
  const UPLOAD_INPUT_ID = "custom-logo-upload";
  const PROPERTY_NAME = "Custom Logo";
  const TEXT_LOGO = document.querySelector('[data-add-text]');

  function isYesChoice(valueText) {
    const v = String(valueText || "").toLowerCase();
    return v.includes("yes") || v.includes("custom logo");
  }

  function getProductForm() {
    return (
      document.querySelector('[data-product-form] form') ||
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('form[action="/cart/add"]')
    );
  }

  function findVariantSelects() {
    return document.querySelector("variant-selects");
  }

  function findLogoGroup() {
  const vs = findVariantSelects();
  if (!vs) return null;

  const target = String(LEGEND_LABEL || "").trim().toLowerCase();
  if (!target) return null;

  // 1) Radio/fieldset themes
  const legends = Array.from(vs.querySelectorAll("fieldset legend, fieldset .form__label"));
  const matchLegend = legends.find((l) => {
    const txt = String(l.textContent || "").trim().toLowerCase();
    return txt === target;
  });
  if (matchLegend) return matchLegend.closest("fieldset");

  // 2) Select dropdown themes (Shopify often uses name="options[OptionName]")
  const selects = Array.from(vs.querySelectorAll("select"));
  const matchSelectByName = selects.find((s) => {
    const n = String(s.getAttribute("name") || "").toLowerCase();
    return n === `options[${target}]` || n.includes(`options[${target}]`);
  });
  if (matchSelectByName) return matchSelectByName;

  // 3) Select with label text (label[for] -> select#id)
  const labels = Array.from(vs.querySelectorAll("label"));
  const matchLabel = labels.find((lb) => {
    const txt = String(lb.textContent || "").trim().toLowerCase();
    return txt === target;
  });
  if (matchLabel) {
    const forId = matchLabel.getAttribute("for");
    if (forId) {
      const sel = vs.querySelector(`#${CSS.escape(forId)}`);
      if (sel && sel.tagName === "SELECT") return sel;
    }
    const near = matchLabel.parentElement?.querySelector("select") || matchLabel.closest("div")?.querySelector("select");
    if (near) return near;
  }

  return null;
}


  function readGroupValue(group) {
  if (!group) return "";

  // If group is a SELECT
  if (group.tagName === "SELECT") {
    const opt = group.options[group.selectedIndex];
    return (opt ? opt.textContent : group.value || "").trim();
  }

  // Radio
  const checked = group.querySelector('input[type="radio"]:checked');
  if (checked) return (checked.value || "").trim();

  // Dropdown inside container
  const sel = group.querySelector("select");
  if (sel) {
    const opt = sel.options[sel.selectedIndex];
    return (opt ? opt.textContent : sel.value || "").trim();
  }

  return "";
}

  function injectStylesOnce() {
    if (document.getElementById("custom-logo-upload-style")) return;
    const st = document.createElement("style");
    st.id = "custom-logo-upload-style";
    st.textContent = `
      .custom-upload-wrapper{margin-top:12px}
      .custom-file-box{
        display:flex; align-items:center; gap:10px;
        padding:10px 12px; border:1px solid rgba(0,0,0,.15);
        border-radius:10px; background:#fff;
      }
      .custom-file-input{display:none}
      .custom-file-btn{
        display:inline-flex; align-items:center; justify-content:center;
        padding:10px 14px; border-radius:10px;
        border:1px solid rgba(0,0,0,.15);
        background:#111; color:#fff; cursor:pointer;
        font-size:14px; line-height:1;
        user-select:none;
        white-space:nowrap;
      }
      .custom-file-btn:hover{opacity:.9}
      .custom-file-name{
        flex:1;
        font-size:14px;
        color:#111;
        overflow:hidden;
        text-overflow:ellipsis;
        white-space:nowrap;
        opacity:.85;
      }
      .custom-file-help{
        display:block;
        margin-top:8px;
        font-size:12px;
        opacity:.75;
      }
      .custom-file-clear{
        border:0;
        background:transparent;
        cursor:pointer;
        font-size:14px;
        opacity:.65;
      }
      .custom-file-clear:hover{opacity:1}
    `;
    document.head.appendChild(st);
  }

  function ensureUploadWrap() {
    const form = getProductForm();
    if (!form) return null;

    let wrap = document.getElementById(UPLOAD_WRAP_ID);
    if (wrap && wrap.closest("form")) return wrap;

    injectStylesOnce();

    wrap = document.createElement("div");
    wrap.id = UPLOAD_WRAP_ID;
    wrap.className = "custom-logo-upload";
    wrap.style.display = "none";
    

    wrap.innerHTML = `
      <div class="product-form__input custom-upload-wrapper">
        <label class="form__label">Upload your logo</label>

        <div class="custom-file-box">
          <label for="${UPLOAD_INPUT_ID}" class="custom-file-btn">Choose File</label>
          <span class="custom-file-name">No file selected</span>
          <button type="button" class="custom-file-clear" aria-label="Clear file">✕</button>

          <input
            id="${UPLOAD_INPUT_ID}"
            type="file"
            accept="image/*"
            name="properties[${PROPERTY_NAME}]"
            class="custom-file-input"
            disabled
          />
        </div>

        <small class="custom-file-help">PNG / JPG / SVG supported.</small>
      </div>
    `;

    const vs = findVariantSelects();
    if (vs && vs.parentNode === form) {
      vs.insertAdjacentElement("afterend", wrap);
    } else {
      form.appendChild(wrap);
    }

    const input = wrap.querySelector(`#${UPLOAD_INPUT_ID}`);
    const nameBox = wrap.querySelector(".custom-file-name");
    const clearBtn = wrap.querySelector(".custom-file-clear");

    input.addEventListener("change", function () {
      nameBox.textContent = this.files && this.files[0] ? this.files[0].name : "No file selected";
    });

    clearBtn.addEventListener("click", () => {
      input.value = "";
      nameBox.textContent = "No file selected";
    });

    return wrap;
  }

  function showUpload() {
    const wrap = ensureUploadWrap();
    if (wrap) {
      wrap.style.display = "";
      wrap.querySelector('#custom-logo-upload').disabled = false;
    }
  }

  function hideUpload() {
    const wrap = ensureUploadWrap();
    if (wrap) {
      wrap.style.display = "none";
      wrap.querySelector('#custom-logo-upload').disabled = true;
  }
  }

  function updateUI() {
    const group = findLogoGroup();
    if (!group) return;

    const v = readGroupValue(group);
    if (isYesChoice(v)) showUpload();
    else hideUpload();
  }

  function init() {
    updateUI();

    document.addEventListener("change", (e) => {
      const el = e.target;
      if (!(el instanceof Element)) return;
      if (!el.closest("variant-selects")) return;
      setTimeout(updateUI, 80);
    });

    document.addEventListener("variant:change", () => {
      setTimeout(updateUI, 50);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
